module.exports = {
	"contractName": "Democracy",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "proposals",
			"outputs": [
				{
					"name": "recipient",
					"type": "address"
				},
				{
					"name": "executed",
					"type": "bool"
				},
				{
					"name": "description",
					"type": "string"
				},
				{
					"name": "proposalHash",
					"type": "bytes32"
				},
				{
					"name": "votingDeadline",
					"type": "uint256"
				},
				{
					"name": "amount",
					"type": "uint256"
				},
				{
					"name": "numberOfVotes",
					"type": "uint256"
				},
				{
					"name": "minimumQuorum",
					"type": "uint256"
				},
				{
					"name": "yes",
					"type": "uint256"
				},
				{
					"name": "no",
					"type": "uint256"
				},
				{
					"name": "debatingPeriodInMinutes",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sharesOwnedAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "pay",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "proposalNumber",
					"type": "uint256"
				},
				{
					"name": "transactionBytecode",
					"type": "bytes"
				}
			],
			"name": "executeProposal",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sharesTokenAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "proposalId",
					"type": "uint256"
				}
			],
			"name": "checkProposalDeadline",
			"outputs": [
				{
					"name": "isDeadlineOver",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "numProposals",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sharesCitizensAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "amountRaised",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "beneficiary",
					"type": "address"
				},
				{
					"name": "minimumVotes",
					"type": "uint256"
				},
				{
					"name": "debatingInMinutes",
					"type": "uint256"
				},
				{
					"name": "weiAmount",
					"type": "uint256"
				},
				{
					"name": "jobDescription",
					"type": "string"
				},
				{
					"name": "transactionBytecode",
					"type": "bytes"
				}
			],
			"name": "newProposal",
			"outputs": [
				{
					"name": "proposalId",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "proposalNumber",
					"type": "uint256"
				},
				{
					"name": "supportsProposal",
					"type": "bool"
				}
			],
			"name": "vote",
			"outputs": [
				{
					"name": "voteId",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "proposalId",
					"type": "uint256"
				},
				{
					"name": "voter",
					"type": "address"
				}
			],
			"name": "checkProposalVoter",
			"outputs": [
				{
					"name": "voted",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "proposalNumber",
					"type": "uint256"
				},
				{
					"name": "beneficiary",
					"type": "address"
				},
				{
					"name": "weiAmount",
					"type": "uint256"
				},
				{
					"name": "transactionBytecode",
					"type": "bytes"
				}
			],
			"name": "checkProposalCode",
			"outputs": [
				{
					"name": "codeChecksOut",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "sharesAddress",
					"type": "address"
				},
				{
					"name": "ownedAddress",
					"type": "address"
				},
				{
					"name": "citizensAddress",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "proposalID",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "recipient",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "minimumVotes",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "debatingInMinutes",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "amount",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "description",
					"type": "string"
				}
			],
			"name": "ProposalAdded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "proposalID",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "position",
					"type": "bool"
				},
				{
					"indexed": false,
					"name": "voter",
					"type": "address"
				}
			],
			"name": "Voted",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "proposalID",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "result",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "quorum",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "active",
					"type": "bool"
				}
			],
			"name": "ProposalTallied",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "newDebatingPeriodInMinutes",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "newSharesTokenAddress",
					"type": "address"
				}
			],
			"name": "ChangeOfRules",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "backer",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "FundTransfer",
			"type": "event"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "353:7968:1:-;;;2177:328;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2308:13;2281:18;;:41;;;;;;;;;;;;;;;;;;2360:12;2333:18;;:40;;;;;;;;;;;;;;;;;;2417:15;2384:21;;:49;;;;;;;;;;;;;;;;;;2444:26;2456:1;2458;2460;2462;2444:26;;;;;;;;;;;;;;;;;;;;;;;;;;:11;;;;;:26;;;:::i;:::-;;2496:1;2481:12;:16;;;;2177:328;;;353:7968;;3143:1044;3429:15;3512:18;1656:1;1610:18;;;;;;;;;;;:31;;;1642:10;1610:43;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:47;1602:56;;;;;;;;1741:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1727:43;;:10;:43;;;;1723:109;;;1818:1;1794:9;:21;1804:10;1794:21;;;;;;;;;;;;;;;;:25;1786:34;;;;;;;;1723:109;3483:9;:18;;;;;;;;;;;:::i;:::-;3470:31;;3533:9;3543:10;3533:21;;;;;;;;;;;;;;;;;;;;3512:42;;3579:11;3565:1;:11;;;:25;;;;;;;;;;;;;;;;;;3612:9;3601:1;:8;;:20;;;;3648:14;3632:1;:13;;:30;;;;;;;;;;;;:::i;:::-;;3700:11;3713:9;3724:19;3690:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:2;51:6;36:153;;;182:3;176:5;171:3;164:6;98:2;93:3;89;82:19;;123:2;118:3;114;107:19;;148:2;143:3;139;132:19;;36:153;;;274:1;267:3;263:2;259:3;254;250;246;315:4;311:3;305;299:5;295:3;356:4;350:3;344:5;340:3;389:7;380;377:2;372:3;365:6;3:399;;;;;;;;;;;;;;;;;;;;;3673:1:1;:14;;:71;;;;;;;3800:9;3780:17;:29;3774:3;:35;3755:1;:16;;:54;;;;3833:5;3820:1;:10;;;:18;;;;;;;;;;;;;;;;;;3867:1;3849;:15;;:19;;;;3887:1;3879;:5;;:9;;;;3906:1;3899;:4;;:8;;;;3936:12;3918:1;:15;;:30;;;;3987:17;3959:1;:25;;:45;;;;4031:1;4015:12;;:17;;;;;;;;;;;4043:98;4057:10;4069:11;4082:12;4096:17;4115:9;4126:14;4043:98;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4169:10:1;4162:17;;3143:1044;;;;;;;;;:::o;353:7968::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "353:7968:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;381:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;515:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2517:200;;;;;;6587:1077;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;477:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6054:241;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;415:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;553:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;603:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;446:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3143:1044;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5155:719;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5886:156;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4487:397;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;381:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;515:31::-;;;;;;;;;;;;;:::o;2517:200::-;2568:11;2063:1;2015:21;;;;;;;;;;;:32;;;2048:10;2015:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:49;;2007:58;;;;;;;;2582:9;2568:23;;2627:6;2602:9;:21;2612:10;2602:21;;;;;;;;;;;;;;;;:31;;;;;;;;;;;2660:6;2644:12;;:22;;;;;;;;;;;2677:32;2690:10;2702:6;2677:32;;;;;;;;;;;;;;;;;;;;;;;;;;;;2517:200;:::o;6587:1077::-;6708:18;1656:1;1610:18;;;;;;;;;;;:31;;;1642:10;1610:43;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:47;1602:56;;;;;;;;1741:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1727:43;;:10;:43;;;;1723:109;;;1818:1;1794:9;:21;1804:10;1794:21;;;;;;;;;;;;;;;;:25;1786:34;;;;;;;;1723:109;6729:9;6739:14;6729:25;;;;;;;;;;;;;;;;;;;;6708:46;;6781:1;:16;;;6775:3;:22;:131;;;;;6896:1;:10;;;;;;;;;;;;6895:11;6775:131;:316;;;;;7048:1;:11;;;;;;;;;;;;7061:1;:8;;;7071:19;7038:53;;;;;;;;;;;;;;;;;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:2;51:6;36:153;;;182:3;176:5;171:3;164:6;98:2;93:3;89;82:19;;123:2;118:3;114;107:19;;148:2;143:3;139;132:19;;36:153;;;274:1;267:3;263:2;259:3;254;250;246;315:4;311:3;305;299:5;295:3;356:4;350:3;344:5;340:3;389:7;380;377:2;372:3;365:6;3:399;;;;;;;;;;;;;;;;;;;;;7020:71:1;;;:1;:14;;;:71;;;;6775:316;:367;;;;;7127:1;:15;;;7108:1;:15;;;:34;;6775:367;6767:376;;;;;;;;7217:1;:4;;;7209:1;:5;;;:12;7205:341;;;7311:4;7298:1;:10;;;:17;;;;;;;;;;;;;;;;;;7356:4;7333:28;;:1;:11;;;;;;;;;;;;:28;;;;7330:126;;;7381:59;7397:1;:11;;;;;;;;;;;;7410:1;:8;;;7420:19;7381:15;:59::i;:::-;7330:126;7205:341;7582:74;7598:14;7622:1;:4;;;7614:1;:5;;;:12;7628:1;:15;;;7645:1;:10;;;;;;;;;;;;7582:74;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6587:1077;;;:::o;477:31::-;;;;;;;;;;;;;:::o;6054:241::-;6127:19;6168:9;6178:10;6168:21;;;;;;;;;;;;;;;;;;;;:36;;;6162:3;:42;6158:130;;;6227:4;6220:11;;;;6158:130;6271:5;6264:12;;6054:241;;;;:::o;415:24::-;;;;:::o;553:37::-;;;;;;;;;;;;;:::o;603:44::-;;;;;;;;;;;;;;;;;:::o;446:24::-;;;;:::o;3143:1044::-;3429:15;3512:18;1656:1;1610:18;;;;;;;;;;;:31;;;1642:10;1610:43;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:47;1602:56;;;;;;;;1741:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1727:43;;:10;:43;;;;1723:109;;;1818:1;1794:9;:21;1804:10;1794:21;;;;;;;;;;;;;;;;:25;1786:34;;;;;;;;1723:109;3483:9;:18;;;;;;;;;;;:::i;:::-;3470:31;;3533:9;3543:10;3533:21;;;;;;;;;;;;;;;;;;;;3512:42;;3579:11;3565:1;:11;;;:25;;;;;;;;;;;;;;;;;;3612:9;3601:1;:8;;:20;;;;3648:14;3632:1;:13;;:30;;;;;;;;;;;;:::i;:::-;;3700:11;3713:9;3724:19;3690:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:2;51:6;36:153;;;182:3;176:5;171:3;164:6;98:2;93:3;89;82:19;;123:2;118:3;114;107:19;;148:2;143:3;139;132:19;;36:153;;;274:1;267:3;263:2;259:3;254;250;246;315:4;311:3;305;299:5;295:3;356:4;350:3;344:5;340:3;389:7;380;377:2;372:3;365:6;3:399;;;;;;;;;;;;;;;;;;;;;3673:1:1;:14;;:71;;;;;;;3800:9;3780:17;:29;3774:3;:35;3755:1;:16;;:54;;;;3833:5;3820:1;:10;;;:18;;;;;;;;;;;;;;;;;;3867:1;3849;:15;;:19;;;;3887:1;3879;:5;;:9;;;;3906:1;3899;:4;;:8;;;;3936:12;3918:1;:15;;:30;;;;3987:17;3959:1;:25;;:45;;;;4031:1;4015:12;;:17;;;;;;;;;;;4043:98;4057:10;4069:11;4082:12;4096:17;4115:9;4126:14;4043:98;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4169:10:1;4162:17;;3143:1044;;;;;;;;;:::o;5155:719::-;5295:11;5332:18;1656:1;1610:18;;;;;;;;;;;:31;;;1642:10;1610:43;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:47;1602:56;;;;;;;;1741:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1727:43;;:10;:43;;;;1723:109;;;1818:1;1794:9;:21;1804:10;1794:21;;;;;;;;;;;;;;;;:25;1786:34;;;;;;;;1723:109;5353:9;5363:14;5353:25;;;;;;;;;;;;;;;;;;;;5332:46;;5420:4;5397:27;;:1;:7;;:19;5405:10;5397:19;;;;;;;;;;;;;;;;;;;;;;;;;:27;;;;:66;;;;;5447:1;:16;;;5441:3;:22;5397:66;5389:75;;;;;;;;5486:1;:7;;:16;;;;;;;;;;;:::i;:::-;5477:25;;5531:54;;;;;;;;;5548:16;5531:54;;;;;;5573:10;5531:54;;;;;5513:1;:7;;5521:6;5513:15;;;;;;;;;;;;;;;;;;:72;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5618:4;5596:1;:7;;:19;5604:10;5596:19;;;;;;;;;;;;;;;;:26;;;;;;;;;;;;;;;;;;5659:1;5651:6;:9;5633:1;:15;;:27;;;;5675:16;5671:100;;;5716:1;5707;:5;;;:10;;;;;;;;;;;5671:100;;;5758:1;5750;:4;;;:9;;;;;;;;;;;5671:100;5781:51;5787:14;5803:16;5821:10;5781:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5860:6;5853:13;;5155:719;;;;;:::o;5886:156::-;5971:10;6000:9;6010:10;6000:21;;;;;;;;;;;;;;;;;;;;:27;;:34;6028:5;6000:34;;;;;;;;;;;;;;;;;;;;;;;;;5993:41;;5886:156;;;;:::o;4487:397::-;4696:18;4740;2063:1;2015:21;;;;;;;;;;;:32;;;2048:10;2015:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:49;;2007:58;;;;;;;;4761:9;4771:14;4761:25;;;;;;;;;;;;;;;;;;;;4740:46;;4832:11;4845:9;4856:19;4822:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:2;51:6;36:153;;;182:3;176:5;171:3;164:6;98:2;93:3;89;82:19;;123:2;118:3;114;107:19;;148:2;143:3;139;132:19;;36:153;;;274:1;267:3;263:2;259:3;254;250;246;315:4;311:3;305;299:5;295:3;356:4;350:3;344:5;340:3;389:7;380;377:2;372:3;365:6;3:399;;;;;;;;;;;;;;;;;;;;;4804:72:1;;;:1;:14;;;:72;;;;4797:79;;4487:397;;;;;;;:::o;7980:338::-;8111:6;8095:4;:12;;;:22;;8087:31;;;;;;;;8145:6;8129:12;;:22;;;;;;;;;;;8170:12;:17;;8194:6;8202:19;8170:52;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8162:61:1;;;;;;;;8276:34;8289:12;8303:6;8276:34;;;;;;;;;;;;;;;;;;;;;;;;;;;;7980:338;;;:::o;353:7968::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::o",
	"source": "pragma solidity ^0.4.16;\r\n\r\ninterface Token {\r\n    function getBalanceOf(address _owner) constant external returns (uint256 balance);\r\n}\r\n\r\ninterface Owned {\r\n    function getOwner() constant external returns (address contractOwner);\r\n}\r\n\r\ninterface Citizens {\r\n    function getCitizen(address _citizen) constant external returns(uint citizenId);\r\n}\r\n\r\ncontract Democracy {\r\n\r\n    Proposal[] public proposals;\r\n    uint public numProposals;\r\n    uint public amountRaised;\r\n    Token public sharesTokenAddress;\r\n    Owned public sharesOwnedAddress;\r\n    Citizens public sharesCitizensAddress;\r\n    \r\n    mapping(address => uint256) public balanceOf;\r\n    \r\n    event ProposalAdded(uint proposalID, address recipient, uint minimumVotes, uint debatingInMinutes, uint amount, string description);\r\n    event Voted(uint proposalID, bool position, address voter);\r\n    event ProposalTallied(uint proposalID, uint result, uint quorum, bool active);\r\n    event ChangeOfRules(uint newDebatingPeriodInMinutes, address newSharesTokenAddress);\r\n    event FundTransfer(address backer, uint amount);\r\n\r\n    struct Proposal {\r\n        address recipient;\r\n        bool executed;\r\n        string description;\r\n        bytes32 proposalHash;\r\n        uint votingDeadline;\r\n        uint amount;\r\n        uint numberOfVotes;\r\n        uint minimumQuorum;\r\n        uint yes;\r\n        uint no;\r\n        uint debatingPeriodInMinutes;\r\n        Vote[] votes;\r\n        mapping (address => bool) voted;\r\n    }\r\n\r\n    struct Vote {\r\n        bool inSupport;\r\n        address voter;\r\n    }\r\n\r\n    modifier onlyShareholders {\r\n        require(sharesTokenAddress.getBalanceOf(msg.sender) > 0);\r\n        _;\r\n    }\r\n    \r\n    modifier onlyInBudget {\r\n        if (msg.sender != sharesOwnedAddress.getOwner()){\r\n            require(balanceOf[msg.sender] > 0);\r\n        }\r\n        _;\r\n    }\r\n    \r\n    modifier onlyOwner {\r\n        require(msg.sender == sharesOwnedAddress.getOwner());\r\n        _;\r\n    }\r\n    \r\n    modifier isCitizen {\r\n        require(sharesCitizensAddress.getCitizen(msg.sender) != 0);\r\n        _;\r\n    }\r\n    \r\n    /**\r\n     * Constructor function\r\n     *\r\n     * First time setup\r\n     */\r\n    function Democracy(Token sharesAddress, Owned ownedAddress, Citizens citizensAddress) public {\r\n        sharesTokenAddress = Token(sharesAddress);\r\n        sharesOwnedAddress = Owned(ownedAddress);\r\n        sharesCitizensAddress = Citizens(citizensAddress);\r\n        newProposal(0,0,0,0,\"\",\"\");\r\n        numProposals = 0;\r\n    }\r\n    \r\n    function pay() payable isCitizen public {\r\n        uint amount = msg.value;\r\n        balanceOf[msg.sender] += amount;\r\n        amountRaised += amount;\r\n        FundTransfer(msg.sender, amount);\r\n    }\r\n\r\n    /**\r\n     * Add Proposal\r\n     *\r\n     * Propose to send `weiAmount / 1e18` ether to `beneficiary` for `jobDescription`. `transactionBytecode ? Contains : Does not contain` code.\r\n     *\r\n     * @param beneficiary who to send the ether to\r\n     * @param weiAmount amount of ether to send, in wei\r\n     * @param jobDescription Description of job\r\n     * @param transactionBytecode bytecode of transaction\r\n     */\r\n    function newProposal(\r\n            address beneficiary,\r\n            uint minimumVotes,\r\n            uint debatingInMinutes,\r\n            uint weiAmount,\r\n            string jobDescription,\r\n            bytes transactionBytecode) \r\n        onlyShareholders onlyInBudget public returns (uint proposalId){\r\n            \r\n        proposalId = proposals.length++;\r\n        Proposal storage p = proposals[proposalId];\r\n        p.recipient = beneficiary;\r\n        p.amount = weiAmount;\r\n        p.description = jobDescription;\r\n        p.proposalHash = keccak256(beneficiary, weiAmount, transactionBytecode);\r\n        p.votingDeadline = now + debatingInMinutes * 1 minutes;\r\n        p.executed = false;\r\n        p.numberOfVotes = 0;\r\n        p.yes = 0;\r\n        p.no = 0;\r\n        p.minimumQuorum = minimumVotes;\r\n        p.debatingPeriodInMinutes = debatingInMinutes;\r\n        numProposals += 1;\r\n        ProposalAdded(proposalId, beneficiary, minimumVotes, debatingInMinutes, weiAmount, jobDescription);\r\n        \r\n        return proposalId;\r\n    }\r\n\r\n    /**\r\n     * Check if a proposal code matches\r\n     *\r\n     * @param proposalNumber ID number of the proposal to query\r\n     * @param beneficiary who to send the ether to\r\n     * @param weiAmount amount of ether to send\r\n     * @param transactionBytecode bytecode of transaction\r\n     */\r\n    function checkProposalCode(\r\n            uint proposalNumber,\r\n            address beneficiary,\r\n            uint weiAmount,\r\n            bytes transactionBytecode)\r\n        isCitizen constant public returns (bool codeChecksOut){\r\n            \r\n        Proposal storage p = proposals[proposalNumber];\r\n        return p.proposalHash == keccak256(beneficiary, weiAmount, transactionBytecode);\r\n    }\r\n\r\n    /**\r\n     * Log a vote for a proposal\r\n     *\r\n     * Vote `supportsProposal? in support of : against` proposal #`proposalNumber`\r\n     *\r\n     * @param proposalNumber number of proposal\r\n     * @param supportsProposal either in favor or against it\r\n     */\r\n    function vote(\r\n            uint proposalNumber,\r\n            bool supportsProposal)\r\n        onlyShareholders onlyInBudget public returns (uint voteId){\r\n            \r\n        Proposal storage p = proposals[proposalNumber];\r\n        require(p.voted[msg.sender] != true\r\n            && now < p.votingDeadline);\r\n\r\n        voteId = p.votes.length++;\r\n        p.votes[voteId] = Vote({inSupport: supportsProposal, voter: msg.sender});\r\n        p.voted[msg.sender] = true;\r\n        p.numberOfVotes = voteId +1;\r\n        if (supportsProposal){\r\n            p.yes += 1;\r\n        } else {\r\n            p.no += 1;\r\n        }\r\n        Voted(proposalNumber, supportsProposal, msg.sender);\r\n        \r\n        return voteId;\r\n    }\r\n    \r\n    function checkProposalVoter(uint proposalId, address voter) public constant returns (bool voted){\r\n        return proposals[proposalId].voted[voter];\r\n    }\r\n    \r\n    function checkProposalDeadline(uint proposalId) public constant returns (bool isDeadlineOver){\r\n        if (now > proposals[proposalId].votingDeadline){\r\n            return true;\r\n        } else {\r\n            return false;\r\n        }\r\n    }\r\n\r\n    /**\r\n     * Finish vote\r\n     *\r\n     * Count the votes proposal #`proposalNumber` and execute it if approved\r\n     *\r\n     * @param proposalNumber proposal number\r\n     * @param transactionBytecode optional: if the transaction contained a bytecode, you need to send it\r\n     */\r\n    function executeProposal(uint proposalNumber, bytes transactionBytecode) onlyShareholders onlyInBudget public {\r\n        Proposal storage p = proposals[proposalNumber];\r\n\r\n        require(now > p.votingDeadline                                             // If it is past the voting deadline\r\n            && !p.executed                                                          // and it has not already been executed\r\n            && p.proposalHash == keccak256(p.recipient, p.amount, transactionBytecode)\r\n            && p.numberOfVotes >= p.minimumQuorum); // and the supplied code matches the proposal...\r\n\r\n        if (p.yes > p.no ) {\r\n            // Proposal passed; execute the transaction\r\n\r\n            p.executed = true;\r\n            if(p.recipient != address(this)){\r\n                _safeWithdrawal(p.recipient, p.amount, transactionBytecode);\r\n            }\r\n            //require(p.recipient.call.value(p.amount)(transactionBytecode));\r\n        }\r\n\r\n        // Fire Events\r\n        ProposalTallied(proposalNumber, p.yes - p.no, p.numberOfVotes, p.executed);\r\n    }\r\n    \r\n    /**\r\n     * Withdraw the funds\r\n     *\r\n     * Checks to see if goal or time limit has been reached, and if so, and the funding goal was reached,\r\n     * sends the entire amount to the beneficiary. If goal was not reached, each contributor can withdraw\r\n     * the amount they contributed.\r\n     */\r\n    function _safeWithdrawal(address _beneficiary, uint _value, bytes transactionBytecode) internal {\r\n        require(this.balance >= _value);\r\n        amountRaised -= _value;\r\n        require(_beneficiary.call.value(_value)(transactionBytecode));\r\n        //_beneficiary.transfer(_value);\r\n        FundTransfer(_beneficiary, _value);\r\n    }\r\n}",
	"sourcePath": "C:\\Users\\nktpa\\Desktop\\truffle-react-auth\\contracts\\Democracy.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/C/Users/nktpa/Desktop/truffle-react-auth/contracts/Democracy.sol",
			"exportedSymbols": {
				"Citizens": [
					259
				],
				"Democracy": [
					899
				],
				"Owned": [
					251
				],
				"Token": [
					245
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 237,
				"name": "PragmaDirective",
				"src": "0:24:1"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "interface",
					"documentation": null,
					"fullyImplemented": false,
					"linearizedBaseContracts": [
						245
					],
					"name": "Token",
					"scope": 900
				},
				"children": [
					{
						"attributes": {
							"body": null,
							"constant": true,
							"implemented": false,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getBalanceOf",
							"payable": false,
							"scope": 245,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "external"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_owner",
											"scope": 244,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 238,
												"name": "ElementaryTypeName",
												"src": "73:7:1"
											}
										],
										"id": 239,
										"name": "VariableDeclaration",
										"src": "73:14:1"
									}
								],
								"id": 240,
								"name": "ParameterList",
								"src": "72:16:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "balance",
											"scope": 244,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 241,
												"name": "ElementaryTypeName",
												"src": "116:7:1"
											}
										],
										"id": 242,
										"name": "VariableDeclaration",
										"src": "116:15:1"
									}
								],
								"id": 243,
								"name": "ParameterList",
								"src": "115:17:1"
							}
						],
						"id": 244,
						"name": "FunctionDefinition",
						"src": "51:82:1"
					}
				],
				"id": 245,
				"name": "ContractDefinition",
				"src": "28:108:1"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "interface",
					"documentation": null,
					"fullyImplemented": false,
					"linearizedBaseContracts": [
						251
					],
					"name": "Owned",
					"scope": 900
				},
				"children": [
					{
						"attributes": {
							"body": null,
							"constant": true,
							"implemented": false,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getOwner",
							"payable": false,
							"scope": 251,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "external"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 246,
								"name": "ParameterList",
								"src": "180:2:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "contractOwner",
											"scope": 250,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 247,
												"name": "ElementaryTypeName",
												"src": "210:7:1"
											}
										],
										"id": 248,
										"name": "VariableDeclaration",
										"src": "210:21:1"
									}
								],
								"id": 249,
								"name": "ParameterList",
								"src": "209:23:1"
							}
						],
						"id": 250,
						"name": "FunctionDefinition",
						"src": "163:70:1"
					}
				],
				"id": 251,
				"name": "ContractDefinition",
				"src": "140:96:1"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "interface",
					"documentation": null,
					"fullyImplemented": false,
					"linearizedBaseContracts": [
						259
					],
					"name": "Citizens",
					"scope": 900
				},
				"children": [
					{
						"attributes": {
							"body": null,
							"constant": true,
							"implemented": false,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getCitizen",
							"payable": false,
							"scope": 259,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "external"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_citizen",
											"scope": 258,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 252,
												"name": "ElementaryTypeName",
												"src": "286:7:1"
											}
										],
										"id": 253,
										"name": "VariableDeclaration",
										"src": "286:16:1"
									}
								],
								"id": 254,
								"name": "ParameterList",
								"src": "285:18:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "citizenId",
											"scope": 258,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 255,
												"name": "ElementaryTypeName",
												"src": "330:4:1"
											}
										],
										"id": 256,
										"name": "VariableDeclaration",
										"src": "330:14:1"
									}
								],
								"id": 257,
								"name": "ParameterList",
								"src": "329:16:1"
							}
						],
						"id": 258,
						"name": "FunctionDefinition",
						"src": "266:80:1"
					}
				],
				"id": 259,
				"name": "ContractDefinition",
				"src": "240:109:1"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						899
					],
					"name": "Democracy",
					"scope": 900
				},
				"children": [
					{
						"attributes": {
							"constant": false,
							"name": "proposals",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "struct Democracy.Proposal storage ref[] storage ref",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"length": null,
									"type": "struct Democracy.Proposal storage ref[] storage pointer"
								},
								"children": [
									{
										"attributes": {
											"contractScope": null,
											"name": "Proposal",
											"referencedDeclaration": 350,
											"type": "struct Democracy.Proposal storage pointer"
										},
										"id": 260,
										"name": "UserDefinedTypeName",
										"src": "381:8:1"
									}
								],
								"id": 261,
								"name": "ArrayTypeName",
								"src": "381:10:1"
							}
						],
						"id": 262,
						"name": "VariableDeclaration",
						"src": "381:27:1"
					},
					{
						"attributes": {
							"constant": false,
							"name": "numProposals",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint",
									"type": "uint256"
								},
								"id": 263,
								"name": "ElementaryTypeName",
								"src": "415:4:1"
							}
						],
						"id": 264,
						"name": "VariableDeclaration",
						"src": "415:24:1"
					},
					{
						"attributes": {
							"constant": false,
							"name": "amountRaised",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint",
									"type": "uint256"
								},
								"id": 265,
								"name": "ElementaryTypeName",
								"src": "446:4:1"
							}
						],
						"id": 266,
						"name": "VariableDeclaration",
						"src": "446:24:1"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sharesTokenAddress",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract Token",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Token",
									"referencedDeclaration": 245,
									"type": "contract Token"
								},
								"id": 267,
								"name": "UserDefinedTypeName",
								"src": "477:5:1"
							}
						],
						"id": 268,
						"name": "VariableDeclaration",
						"src": "477:31:1"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sharesOwnedAddress",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract Owned",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Owned",
									"referencedDeclaration": 251,
									"type": "contract Owned"
								},
								"id": 269,
								"name": "UserDefinedTypeName",
								"src": "515:5:1"
							}
						],
						"id": 270,
						"name": "VariableDeclaration",
						"src": "515:31:1"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sharesCitizensAddress",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract Citizens",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Citizens",
									"referencedDeclaration": 259,
									"type": "contract Citizens"
								},
								"id": 271,
								"name": "UserDefinedTypeName",
								"src": "553:8:1"
							}
						],
						"id": 272,
						"name": "VariableDeclaration",
						"src": "553:37:1"
					},
					{
						"attributes": {
							"constant": false,
							"name": "balanceOf",
							"scope": 899,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => uint256)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => uint256)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 273,
										"name": "ElementaryTypeName",
										"src": "611:7:1"
									},
									{
										"attributes": {
											"name": "uint256",
											"type": "uint256"
										},
										"id": 274,
										"name": "ElementaryTypeName",
										"src": "622:7:1"
									}
								],
								"id": 275,
								"name": "Mapping",
								"src": "603:27:1"
							}
						],
						"id": 276,
						"name": "VariableDeclaration",
						"src": "603:44:1"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "ProposalAdded"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "proposalID",
											"scope": 290,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 277,
												"name": "ElementaryTypeName",
												"src": "680:4:1"
											}
										],
										"id": 278,
										"name": "VariableDeclaration",
										"src": "680:15:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "recipient",
											"scope": 290,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 279,
												"name": "ElementaryTypeName",
												"src": "697:7:1"
											}
										],
										"id": 280,
										"name": "VariableDeclaration",
										"src": "697:17:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "minimumVotes",
											"scope": 290,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 281,
												"name": "ElementaryTypeName",
												"src": "716:4:1"
											}
										],
										"id": 282,
										"name": "VariableDeclaration",
										"src": "716:17:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "debatingInMinutes",
											"scope": 290,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 283,
												"name": "ElementaryTypeName",
												"src": "735:4:1"
											}
										],
										"id": 284,
										"name": "VariableDeclaration",
										"src": "735:22:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "amount",
											"scope": 290,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 285,
												"name": "ElementaryTypeName",
												"src": "759:4:1"
											}
										],
										"id": 286,
										"name": "VariableDeclaration",
										"src": "759:11:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "description",
											"scope": 290,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 287,
												"name": "ElementaryTypeName",
												"src": "772:6:1"
											}
										],
										"id": 288,
										"name": "VariableDeclaration",
										"src": "772:18:1"
									}
								],
								"id": 289,
								"name": "ParameterList",
								"src": "679:112:1"
							}
						],
						"id": 290,
						"name": "EventDefinition",
						"src": "660:132:1"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "Voted"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "proposalID",
											"scope": 298,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 291,
												"name": "ElementaryTypeName",
												"src": "810:4:1"
											}
										],
										"id": 292,
										"name": "VariableDeclaration",
										"src": "810:15:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "position",
											"scope": 298,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 293,
												"name": "ElementaryTypeName",
												"src": "827:4:1"
											}
										],
										"id": 294,
										"name": "VariableDeclaration",
										"src": "827:13:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "voter",
											"scope": 298,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 295,
												"name": "ElementaryTypeName",
												"src": "842:7:1"
											}
										],
										"id": 296,
										"name": "VariableDeclaration",
										"src": "842:13:1"
									}
								],
								"id": 297,
								"name": "ParameterList",
								"src": "809:47:1"
							}
						],
						"id": 298,
						"name": "EventDefinition",
						"src": "798:59:1"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "ProposalTallied"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "proposalID",
											"scope": 308,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 299,
												"name": "ElementaryTypeName",
												"src": "885:4:1"
											}
										],
										"id": 300,
										"name": "VariableDeclaration",
										"src": "885:15:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "result",
											"scope": 308,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 301,
												"name": "ElementaryTypeName",
												"src": "902:4:1"
											}
										],
										"id": 302,
										"name": "VariableDeclaration",
										"src": "902:11:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "quorum",
											"scope": 308,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 303,
												"name": "ElementaryTypeName",
												"src": "915:4:1"
											}
										],
										"id": 304,
										"name": "VariableDeclaration",
										"src": "915:11:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "active",
											"scope": 308,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 305,
												"name": "ElementaryTypeName",
												"src": "928:4:1"
											}
										],
										"id": 306,
										"name": "VariableDeclaration",
										"src": "928:11:1"
									}
								],
								"id": 307,
								"name": "ParameterList",
								"src": "884:56:1"
							}
						],
						"id": 308,
						"name": "EventDefinition",
						"src": "863:78:1"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "ChangeOfRules"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "newDebatingPeriodInMinutes",
											"scope": 314,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 309,
												"name": "ElementaryTypeName",
												"src": "967:4:1"
											}
										],
										"id": 310,
										"name": "VariableDeclaration",
										"src": "967:31:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "newSharesTokenAddress",
											"scope": 314,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 311,
												"name": "ElementaryTypeName",
												"src": "1000:7:1"
											}
										],
										"id": 312,
										"name": "VariableDeclaration",
										"src": "1000:29:1"
									}
								],
								"id": 313,
								"name": "ParameterList",
								"src": "966:64:1"
							}
						],
						"id": 314,
						"name": "EventDefinition",
						"src": "947:84:1"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "FundTransfer"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "backer",
											"scope": 320,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 315,
												"name": "ElementaryTypeName",
												"src": "1056:7:1"
											}
										],
										"id": 316,
										"name": "VariableDeclaration",
										"src": "1056:14:1"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "amount",
											"scope": 320,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 317,
												"name": "ElementaryTypeName",
												"src": "1072:4:1"
											}
										],
										"id": 318,
										"name": "VariableDeclaration",
										"src": "1072:11:1"
									}
								],
								"id": 319,
								"name": "ParameterList",
								"src": "1055:29:1"
							}
						],
						"id": 320,
						"name": "EventDefinition",
						"src": "1037:48:1"
					},
					{
						"attributes": {
							"canonicalName": "Democracy.Proposal",
							"name": "Proposal",
							"scope": 899,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"constant": false,
									"name": "recipient",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "address",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 321,
										"name": "ElementaryTypeName",
										"src": "1120:7:1"
									}
								],
								"id": 322,
								"name": "VariableDeclaration",
								"src": "1120:17:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "executed",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bool",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 323,
										"name": "ElementaryTypeName",
										"src": "1148:4:1"
									}
								],
								"id": 324,
								"name": "VariableDeclaration",
								"src": "1148:13:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "description",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "string storage pointer",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "string",
											"type": "string storage pointer"
										},
										"id": 325,
										"name": "ElementaryTypeName",
										"src": "1172:6:1"
									}
								],
								"id": 326,
								"name": "VariableDeclaration",
								"src": "1172:18:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "proposalHash",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bytes32",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 327,
										"name": "ElementaryTypeName",
										"src": "1201:7:1"
									}
								],
								"id": 328,
								"name": "VariableDeclaration",
								"src": "1201:20:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "votingDeadline",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 329,
										"name": "ElementaryTypeName",
										"src": "1232:4:1"
									}
								],
								"id": 330,
								"name": "VariableDeclaration",
								"src": "1232:19:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "amount",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 331,
										"name": "ElementaryTypeName",
										"src": "1262:4:1"
									}
								],
								"id": 332,
								"name": "VariableDeclaration",
								"src": "1262:11:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "numberOfVotes",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 333,
										"name": "ElementaryTypeName",
										"src": "1284:4:1"
									}
								],
								"id": 334,
								"name": "VariableDeclaration",
								"src": "1284:18:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "minimumQuorum",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 335,
										"name": "ElementaryTypeName",
										"src": "1313:4:1"
									}
								],
								"id": 336,
								"name": "VariableDeclaration",
								"src": "1313:18:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "yes",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 337,
										"name": "ElementaryTypeName",
										"src": "1342:4:1"
									}
								],
								"id": 338,
								"name": "VariableDeclaration",
								"src": "1342:8:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "no",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 339,
										"name": "ElementaryTypeName",
										"src": "1361:4:1"
									}
								],
								"id": 340,
								"name": "VariableDeclaration",
								"src": "1361:7:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "debatingPeriodInMinutes",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 341,
										"name": "ElementaryTypeName",
										"src": "1379:4:1"
									}
								],
								"id": 342,
								"name": "VariableDeclaration",
								"src": "1379:28:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "votes",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "struct Democracy.Vote storage ref[] storage pointer",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"length": null,
											"type": "struct Democracy.Vote storage ref[] storage pointer"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Vote",
													"referencedDeclaration": 355,
													"type": "struct Democracy.Vote storage pointer"
												},
												"id": 343,
												"name": "UserDefinedTypeName",
												"src": "1418:4:1"
											}
										],
										"id": 344,
										"name": "ArrayTypeName",
										"src": "1418:6:1"
									}
								],
								"id": 345,
								"name": "VariableDeclaration",
								"src": "1418:12:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "voted",
									"scope": 350,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "mapping(address => bool)",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"type": "mapping(address => bool)"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 346,
												"name": "ElementaryTypeName",
												"src": "1450:7:1"
											},
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 347,
												"name": "ElementaryTypeName",
												"src": "1461:4:1"
											}
										],
										"id": 348,
										"name": "Mapping",
										"src": "1441:25:1"
									}
								],
								"id": 349,
								"name": "VariableDeclaration",
								"src": "1441:31:1"
							}
						],
						"id": 350,
						"name": "StructDefinition",
						"src": "1093:387:1"
					},
					{
						"attributes": {
							"canonicalName": "Democracy.Vote",
							"name": "Vote",
							"scope": 899,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"constant": false,
									"name": "inSupport",
									"scope": 355,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bool",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 351,
										"name": "ElementaryTypeName",
										"src": "1511:4:1"
									}
								],
								"id": 352,
								"name": "VariableDeclaration",
								"src": "1511:14:1"
							},
							{
								"attributes": {
									"constant": false,
									"name": "voter",
									"scope": 355,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "address",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 353,
										"name": "ElementaryTypeName",
										"src": "1536:7:1"
									}
								],
								"id": 354,
								"name": "VariableDeclaration",
								"src": "1536:13:1"
							}
						],
						"id": 355,
						"name": "StructDefinition",
						"src": "1488:69:1"
					},
					{
						"attributes": {
							"name": "onlyShareholders",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 356,
								"name": "ParameterList",
								"src": "1591:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 357,
														"name": "Identifier",
														"src": "1602:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": ">",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "uint256",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getBalanceOf",
																			"referencedDeclaration": 244,
																			"type": "function (address) view external returns (uint256)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 268,
																					"type": "contract Token",
																					"value": "sharesTokenAddress"
																				},
																				"id": 358,
																				"name": "Identifier",
																				"src": "1610:18:1"
																			}
																		],
																		"id": 359,
																		"name": "MemberAccess",
																		"src": "1610:31:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1394,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 360,
																				"name": "Identifier",
																				"src": "1642:3:1"
																			}
																		],
																		"id": 361,
																		"name": "MemberAccess",
																		"src": "1642:10:1"
																	}
																],
																"id": 362,
																"name": "FunctionCall",
																"src": "1610:43:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 363,
																"name": "Literal",
																"src": "1656:1:1"
															}
														],
														"id": 364,
														"name": "BinaryOperation",
														"src": "1610:47:1"
													}
												],
												"id": 365,
												"name": "FunctionCall",
												"src": "1602:56:1"
											}
										],
										"id": 366,
										"name": "ExpressionStatement",
										"src": "1602:56:1"
									},
									{
										"id": 367,
										"name": "PlaceholderStatement",
										"src": "1669:1:1"
									}
								],
								"id": 368,
								"name": "Block",
								"src": "1591:87:1"
							}
						],
						"id": 369,
						"name": "ModifierDefinition",
						"src": "1565:113:1"
					},
					{
						"attributes": {
							"name": "onlyInBudget",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 370,
								"name": "ParameterList",
								"src": "1712:0:1"
							},
							{
								"children": [
									{
										"attributes": {
											"falseBody": null
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "!=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1394,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 371,
																"name": "Identifier",
																"src": "1727:3:1"
															}
														],
														"id": 372,
														"name": "MemberAccess",
														"src": "1727:10:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"arguments": [
																null
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "address",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "getOwner",
																	"referencedDeclaration": 250,
																	"type": "function () view external returns (address)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 270,
																			"type": "contract Owned",
																			"value": "sharesOwnedAddress"
																		},
																		"id": 373,
																		"name": "Identifier",
																		"src": "1741:18:1"
																	}
																],
																"id": 374,
																"name": "MemberAccess",
																"src": "1741:27:1"
															}
														],
														"id": 375,
														"name": "FunctionCall",
														"src": "1741:29:1"
													}
												],
												"id": 376,
												"name": "BinaryOperation",
												"src": "1727:43:1"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "tuple()",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			],
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1397,
																			"type": "function (bool) pure",
																			"value": "require"
																		},
																		"id": 377,
																		"name": "Identifier",
																		"src": "1786:7:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": ">",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"type": "uint256"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 276,
																							"type": "mapping(address => uint256)",
																							"value": "balanceOf"
																						},
																						"id": 378,
																						"name": "Identifier",
																						"src": "1794:9:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "sender",
																							"referencedDeclaration": null,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1394,
																									"type": "msg",
																									"value": "msg"
																								},
																								"id": 379,
																								"name": "Identifier",
																								"src": "1804:3:1"
																							}
																						],
																						"id": 380,
																						"name": "MemberAccess",
																						"src": "1804:10:1"
																					}
																				],
																				"id": 381,
																				"name": "IndexAccess",
																				"src": "1794:21:1"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"hexvalue": "30",
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"subdenomination": null,
																					"token": "number",
																					"type": "int_const 0",
																					"value": "0"
																				},
																				"id": 382,
																				"name": "Literal",
																				"src": "1818:1:1"
																			}
																		],
																		"id": 383,
																		"name": "BinaryOperation",
																		"src": "1794:25:1"
																	}
																],
																"id": 384,
																"name": "FunctionCall",
																"src": "1786:34:1"
															}
														],
														"id": 385,
														"name": "ExpressionStatement",
														"src": "1786:34:1"
													}
												],
												"id": 386,
												"name": "Block",
												"src": "1771:61:1"
											}
										],
										"id": 387,
										"name": "IfStatement",
										"src": "1723:109:1"
									},
									{
										"id": 388,
										"name": "PlaceholderStatement",
										"src": "1842:1:1"
									}
								],
								"id": 389,
								"name": "Block",
								"src": "1712:139:1"
							}
						],
						"id": 390,
						"name": "ModifierDefinition",
						"src": "1690:161:1"
					},
					{
						"attributes": {
							"name": "onlyOwner",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 391,
								"name": "ParameterList",
								"src": "1882:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 392,
														"name": "Identifier",
														"src": "1893:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "==",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 393,
																		"name": "Identifier",
																		"src": "1901:3:1"
																	}
																],
																"id": 394,
																"name": "MemberAccess",
																"src": "1901:10:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"arguments": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "address",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				null
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getOwner",
																			"referencedDeclaration": 250,
																			"type": "function () view external returns (address)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 270,
																					"type": "contract Owned",
																					"value": "sharesOwnedAddress"
																				},
																				"id": 395,
																				"name": "Identifier",
																				"src": "1915:18:1"
																			}
																		],
																		"id": 396,
																		"name": "MemberAccess",
																		"src": "1915:27:1"
																	}
																],
																"id": 397,
																"name": "FunctionCall",
																"src": "1915:29:1"
															}
														],
														"id": 398,
														"name": "BinaryOperation",
														"src": "1901:43:1"
													}
												],
												"id": 399,
												"name": "FunctionCall",
												"src": "1893:52:1"
											}
										],
										"id": 400,
										"name": "ExpressionStatement",
										"src": "1893:52:1"
									},
									{
										"id": 401,
										"name": "PlaceholderStatement",
										"src": "1956:1:1"
									}
								],
								"id": 402,
								"name": "Block",
								"src": "1882:83:1"
							}
						],
						"id": 403,
						"name": "ModifierDefinition",
						"src": "1863:102:1"
					},
					{
						"attributes": {
							"name": "isCitizen",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 404,
								"name": "ParameterList",
								"src": "1996:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 405,
														"name": "Identifier",
														"src": "2007:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "!=",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "uint256",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getCitizen",
																			"referencedDeclaration": 258,
																			"type": "function (address) view external returns (uint256)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 272,
																					"type": "contract Citizens",
																					"value": "sharesCitizensAddress"
																				},
																				"id": 406,
																				"name": "Identifier",
																				"src": "2015:21:1"
																			}
																		],
																		"id": 407,
																		"name": "MemberAccess",
																		"src": "2015:32:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1394,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 408,
																				"name": "Identifier",
																				"src": "2048:3:1"
																			}
																		],
																		"id": 409,
																		"name": "MemberAccess",
																		"src": "2048:10:1"
																	}
																],
																"id": 410,
																"name": "FunctionCall",
																"src": "2015:44:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 411,
																"name": "Literal",
																"src": "2063:1:1"
															}
														],
														"id": 412,
														"name": "BinaryOperation",
														"src": "2015:49:1"
													}
												],
												"id": 413,
												"name": "FunctionCall",
												"src": "2007:58:1"
											}
										],
										"id": 414,
										"name": "ExpressionStatement",
										"src": "2007:58:1"
									},
									{
										"id": 415,
										"name": "PlaceholderStatement",
										"src": "2076:1:1"
									}
								],
								"id": 416,
								"name": "Block",
								"src": "1996:89:1"
							}
						],
						"id": 417,
						"name": "ModifierDefinition",
						"src": "1977:108:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "Democracy",
							"payable": false,
							"scope": 899,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "sharesAddress",
											"scope": 458,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "contract Token",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Token",
													"referencedDeclaration": 245,
													"type": "contract Token"
												},
												"id": 418,
												"name": "UserDefinedTypeName",
												"src": "2196:5:1"
											}
										],
										"id": 419,
										"name": "VariableDeclaration",
										"src": "2196:19:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "ownedAddress",
											"scope": 458,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "contract Owned",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Owned",
													"referencedDeclaration": 251,
													"type": "contract Owned"
												},
												"id": 420,
												"name": "UserDefinedTypeName",
												"src": "2217:5:1"
											}
										],
										"id": 421,
										"name": "VariableDeclaration",
										"src": "2217:18:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "citizensAddress",
											"scope": 458,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "contract Citizens",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Citizens",
													"referencedDeclaration": 259,
													"type": "contract Citizens"
												},
												"id": 422,
												"name": "UserDefinedTypeName",
												"src": "2237:8:1"
											}
										],
										"id": 423,
										"name": "VariableDeclaration",
										"src": "2237:24:1"
									}
								],
								"id": 424,
								"name": "ParameterList",
								"src": "2195:67:1"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 425,
								"name": "ParameterList",
								"src": "2270:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract Token"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 268,
															"type": "contract Token",
															"value": "sharesTokenAddress"
														},
														"id": 426,
														"name": "Identifier",
														"src": "2281:18:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract Token",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_contract$_Token_$245",
																			"typeString": "contract Token"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 245,
																	"type": "type(contract Token)",
																	"value": "Token"
																},
																"id": 427,
																"name": "Identifier",
																"src": "2302:5:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 419,
																	"type": "contract Token",
																	"value": "sharesAddress"
																},
																"id": 428,
																"name": "Identifier",
																"src": "2308:13:1"
															}
														],
														"id": 429,
														"name": "FunctionCall",
														"src": "2302:20:1"
													}
												],
												"id": 430,
												"name": "Assignment",
												"src": "2281:41:1"
											}
										],
										"id": 431,
										"name": "ExpressionStatement",
										"src": "2281:41:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract Owned"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 270,
															"type": "contract Owned",
															"value": "sharesOwnedAddress"
														},
														"id": 432,
														"name": "Identifier",
														"src": "2333:18:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract Owned",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_contract$_Owned_$251",
																			"typeString": "contract Owned"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 251,
																	"type": "type(contract Owned)",
																	"value": "Owned"
																},
																"id": 433,
																"name": "Identifier",
																"src": "2354:5:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 421,
																	"type": "contract Owned",
																	"value": "ownedAddress"
																},
																"id": 434,
																"name": "Identifier",
																"src": "2360:12:1"
															}
														],
														"id": 435,
														"name": "FunctionCall",
														"src": "2354:19:1"
													}
												],
												"id": 436,
												"name": "Assignment",
												"src": "2333:40:1"
											}
										],
										"id": 437,
										"name": "ExpressionStatement",
										"src": "2333:40:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract Citizens"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 272,
															"type": "contract Citizens",
															"value": "sharesCitizensAddress"
														},
														"id": 438,
														"name": "Identifier",
														"src": "2384:21:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract Citizens",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_contract$_Citizens_$259",
																			"typeString": "contract Citizens"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 259,
																	"type": "type(contract Citizens)",
																	"value": "Citizens"
																},
																"id": 439,
																"name": "Identifier",
																"src": "2408:8:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 423,
																	"type": "contract Citizens",
																	"value": "citizensAddress"
																},
																"id": 440,
																"name": "Identifier",
																"src": "2417:15:1"
															}
														],
														"id": 441,
														"name": "FunctionCall",
														"src": "2408:25:1"
													}
												],
												"id": 442,
												"name": "Assignment",
												"src": "2384:49:1"
											}
										],
										"id": 443,
										"name": "ExpressionStatement",
										"src": "2384:49:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "uint256",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																{
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																{
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																{
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																{
																	"typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
																	"typeString": "literal_string \"\""
																},
																{
																	"typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
																	"typeString": "literal_string \"\""
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 609,
															"type": "function (address,uint256,uint256,uint256,string memory,bytes memory) returns (uint256)",
															"value": "newProposal"
														},
														"id": 444,
														"name": "Identifier",
														"src": "2444:11:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 445,
														"name": "Literal",
														"src": "2456:1:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 446,
														"name": "Literal",
														"src": "2458:1:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 447,
														"name": "Literal",
														"src": "2460:1:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 448,
														"name": "Literal",
														"src": "2462:1:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "string",
															"type": "literal_string \"\"",
															"value": ""
														},
														"id": 449,
														"name": "Literal",
														"src": "2464:2:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "string",
															"type": "literal_string \"\"",
															"value": ""
														},
														"id": 450,
														"name": "Literal",
														"src": "2467:2:1"
													}
												],
												"id": 451,
												"name": "FunctionCall",
												"src": "2444:26:1"
											}
										],
										"id": 452,
										"name": "ExpressionStatement",
										"src": "2444:26:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 264,
															"type": "uint256",
															"value": "numProposals"
														},
														"id": 453,
														"name": "Identifier",
														"src": "2481:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 454,
														"name": "Literal",
														"src": "2496:1:1"
													}
												],
												"id": 455,
												"name": "Assignment",
												"src": "2481:16:1"
											}
										],
										"id": 456,
										"name": "ExpressionStatement",
										"src": "2481:16:1"
									}
								],
								"id": 457,
								"name": "Block",
								"src": "2270:235:1"
							}
						],
						"id": 458,
						"name": "FunctionDefinition",
						"src": "2177:328:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "pay",
							"payable": true,
							"scope": 899,
							"stateMutability": "payable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 459,
								"name": "ParameterList",
								"src": "2529:2:1"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 462,
								"name": "ParameterList",
								"src": "2557:0:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 417,
											"type": "modifier ()",
											"value": "isCitizen"
										},
										"id": 460,
										"name": "Identifier",
										"src": "2540:9:1"
									}
								],
								"id": 461,
								"name": "ModifierInvocation",
								"src": "2540:9:1"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												464
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "amount",
													"scope": 486,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint",
															"type": "uint256"
														},
														"id": 463,
														"name": "ElementaryTypeName",
														"src": "2568:4:1"
													}
												],
												"id": 464,
												"name": "VariableDeclaration",
												"src": "2568:11:1"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"member_name": "value",
													"referencedDeclaration": null,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1394,
															"type": "msg",
															"value": "msg"
														},
														"id": 465,
														"name": "Identifier",
														"src": "2582:3:1"
													}
												],
												"id": 466,
												"name": "MemberAccess",
												"src": "2582:9:1"
											}
										],
										"id": 467,
										"name": "VariableDeclarationStatement",
										"src": "2568:23:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 276,
																	"type": "mapping(address => uint256)",
																	"value": "balanceOf"
																},
																"id": 468,
																"name": "Identifier",
																"src": "2602:9:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 469,
																		"name": "Identifier",
																		"src": "2612:3:1"
																	}
																],
																"id": 470,
																"name": "MemberAccess",
																"src": "2612:10:1"
															}
														],
														"id": 471,
														"name": "IndexAccess",
														"src": "2602:21:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 464,
															"type": "uint256",
															"value": "amount"
														},
														"id": 472,
														"name": "Identifier",
														"src": "2627:6:1"
													}
												],
												"id": 473,
												"name": "Assignment",
												"src": "2602:31:1"
											}
										],
										"id": 474,
										"name": "ExpressionStatement",
										"src": "2602:31:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 266,
															"type": "uint256",
															"value": "amountRaised"
														},
														"id": 475,
														"name": "Identifier",
														"src": "2644:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 464,
															"type": "uint256",
															"value": "amount"
														},
														"id": 476,
														"name": "Identifier",
														"src": "2660:6:1"
													}
												],
												"id": 477,
												"name": "Assignment",
												"src": "2644:22:1"
											}
										],
										"id": 478,
										"name": "ExpressionStatement",
										"src": "2644:22:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 320,
															"type": "function (address,uint256)",
															"value": "FundTransfer"
														},
														"id": 479,
														"name": "Identifier",
														"src": "2677:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1394,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 480,
																"name": "Identifier",
																"src": "2690:3:1"
															}
														],
														"id": 481,
														"name": "MemberAccess",
														"src": "2690:10:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 464,
															"type": "uint256",
															"value": "amount"
														},
														"id": 482,
														"name": "Identifier",
														"src": "2702:6:1"
													}
												],
												"id": 483,
												"name": "FunctionCall",
												"src": "2677:32:1"
											}
										],
										"id": 484,
										"name": "ExpressionStatement",
										"src": "2677:32:1"
									}
								],
								"id": 485,
								"name": "Block",
								"src": "2557:160:1"
							}
						],
						"id": 486,
						"name": "FunctionDefinition",
						"src": "2517:200:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "newProposal",
							"payable": false,
							"scope": 899,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "beneficiary",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 487,
												"name": "ElementaryTypeName",
												"src": "3178:7:1"
											}
										],
										"id": 488,
										"name": "VariableDeclaration",
										"src": "3178:19:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "minimumVotes",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 489,
												"name": "ElementaryTypeName",
												"src": "3212:4:1"
											}
										],
										"id": 490,
										"name": "VariableDeclaration",
										"src": "3212:17:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "debatingInMinutes",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 491,
												"name": "ElementaryTypeName",
												"src": "3244:4:1"
											}
										],
										"id": 492,
										"name": "VariableDeclaration",
										"src": "3244:22:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "weiAmount",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 493,
												"name": "ElementaryTypeName",
												"src": "3281:4:1"
											}
										],
										"id": 494,
										"name": "VariableDeclaration",
										"src": "3281:14:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "jobDescription",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 495,
												"name": "ElementaryTypeName",
												"src": "3310:6:1"
											}
										],
										"id": 496,
										"name": "VariableDeclaration",
										"src": "3310:21:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "transactionBytecode",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes",
													"type": "bytes storage pointer"
												},
												"id": 497,
												"name": "ElementaryTypeName",
												"src": "3346:5:1"
											}
										],
										"id": 498,
										"name": "VariableDeclaration",
										"src": "3346:25:1"
									}
								],
								"id": 499,
								"name": "ParameterList",
								"src": "3163:209:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "proposalId",
											"scope": 609,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 504,
												"name": "ElementaryTypeName",
												"src": "3429:4:1"
											}
										],
										"id": 505,
										"name": "VariableDeclaration",
										"src": "3429:15:1"
									}
								],
								"id": 506,
								"name": "ParameterList",
								"src": "3428:17:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 369,
											"type": "modifier ()",
											"value": "onlyShareholders"
										},
										"id": 500,
										"name": "Identifier",
										"src": "3383:16:1"
									}
								],
								"id": 501,
								"name": "ModifierInvocation",
								"src": "3383:16:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 390,
											"type": "modifier ()",
											"value": "onlyInBudget"
										},
										"id": 502,
										"name": "Identifier",
										"src": "3400:12:1"
									}
								],
								"id": 503,
								"name": "ModifierInvocation",
								"src": "3400:12:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 505,
															"type": "uint256",
															"value": "proposalId"
														},
														"id": 507,
														"name": "Identifier",
														"src": "3470:10:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "++",
															"prefix": false,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"member_name": "length",
																	"referencedDeclaration": null,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 262,
																			"type": "struct Democracy.Proposal storage ref[] storage ref",
																			"value": "proposals"
																		},
																		"id": 508,
																		"name": "Identifier",
																		"src": "3483:9:1"
																	}
																],
																"id": 509,
																"name": "MemberAccess",
																"src": "3483:16:1"
															}
														],
														"id": 510,
														"name": "UnaryOperation",
														"src": "3483:18:1"
													}
												],
												"id": 511,
												"name": "Assignment",
												"src": "3470:31:1"
											}
										],
										"id": 512,
										"name": "ExpressionStatement",
										"src": "3470:31:1"
									},
									{
										"attributes": {
											"assignments": [
												514
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "p",
													"scope": 609,
													"stateVariable": false,
													"storageLocation": "storage",
													"type": "struct Democracy.Proposal storage pointer",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"contractScope": null,
															"name": "Proposal",
															"referencedDeclaration": 350,
															"type": "struct Democracy.Proposal storage pointer"
														},
														"id": 513,
														"name": "UserDefinedTypeName",
														"src": "3512:8:1"
													}
												],
												"id": 514,
												"name": "VariableDeclaration",
												"src": "3512:18:1"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct Democracy.Proposal storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 262,
															"type": "struct Democracy.Proposal storage ref[] storage ref",
															"value": "proposals"
														},
														"id": 515,
														"name": "Identifier",
														"src": "3533:9:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 505,
															"type": "uint256",
															"value": "proposalId"
														},
														"id": 516,
														"name": "Identifier",
														"src": "3543:10:1"
													}
												],
												"id": 517,
												"name": "IndexAccess",
												"src": "3533:21:1"
											}
										],
										"id": 518,
										"name": "VariableDeclarationStatement",
										"src": "3512:42:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "recipient",
															"referencedDeclaration": 322,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 519,
																"name": "Identifier",
																"src": "3565:1:1"
															}
														],
														"id": 521,
														"name": "MemberAccess",
														"src": "3565:11:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 488,
															"type": "address",
															"value": "beneficiary"
														},
														"id": 522,
														"name": "Identifier",
														"src": "3579:11:1"
													}
												],
												"id": 523,
												"name": "Assignment",
												"src": "3565:25:1"
											}
										],
										"id": 524,
										"name": "ExpressionStatement",
										"src": "3565:25:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "amount",
															"referencedDeclaration": 332,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 525,
																"name": "Identifier",
																"src": "3601:1:1"
															}
														],
														"id": 527,
														"name": "MemberAccess",
														"src": "3601:8:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 494,
															"type": "uint256",
															"value": "weiAmount"
														},
														"id": 528,
														"name": "Identifier",
														"src": "3612:9:1"
													}
												],
												"id": 529,
												"name": "Assignment",
												"src": "3601:20:1"
											}
										],
										"id": 530,
										"name": "ExpressionStatement",
										"src": "3601:20:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "string storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "description",
															"referencedDeclaration": 326,
															"type": "string storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 531,
																"name": "Identifier",
																"src": "3632:1:1"
															}
														],
														"id": 533,
														"name": "MemberAccess",
														"src": "3632:13:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 496,
															"type": "string memory",
															"value": "jobDescription"
														},
														"id": 534,
														"name": "Identifier",
														"src": "3648:14:1"
													}
												],
												"id": 535,
												"name": "Assignment",
												"src": "3632:30:1"
											}
										],
										"id": 536,
										"name": "ExpressionStatement",
										"src": "3632:30:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bytes32"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "proposalHash",
															"referencedDeclaration": 328,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 537,
																"name": "Identifier",
																"src": "3673:1:1"
															}
														],
														"id": 539,
														"name": "MemberAccess",
														"src": "3673:14:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "bytes32",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		},
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_bytes_memory_ptr",
																			"typeString": "bytes memory"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1388,
																	"type": "function () pure returns (bytes32)",
																	"value": "keccak256"
																},
																"id": 540,
																"name": "Identifier",
																"src": "3690:9:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 488,
																	"type": "address",
																	"value": "beneficiary"
																},
																"id": 541,
																"name": "Identifier",
																"src": "3700:11:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 494,
																	"type": "uint256",
																	"value": "weiAmount"
																},
																"id": 542,
																"name": "Identifier",
																"src": "3713:9:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 498,
																	"type": "bytes memory",
																	"value": "transactionBytecode"
																},
																"id": 543,
																"name": "Identifier",
																"src": "3724:19:1"
															}
														],
														"id": 544,
														"name": "FunctionCall",
														"src": "3690:54:1"
													}
												],
												"id": 545,
												"name": "Assignment",
												"src": "3673:71:1"
											}
										],
										"id": 546,
										"name": "ExpressionStatement",
										"src": "3673:71:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "votingDeadline",
															"referencedDeclaration": 330,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 547,
																"name": "Identifier",
																"src": "3755:1:1"
															}
														],
														"id": 549,
														"name": "MemberAccess",
														"src": "3755:16:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "+",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1396,
																	"type": "uint256",
																	"value": "now"
																},
																"id": 550,
																"name": "Identifier",
																"src": "3774:3:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "*",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 492,
																			"type": "uint256",
																			"value": "debatingInMinutes"
																		},
																		"id": 551,
																		"name": "Identifier",
																		"src": "3780:17:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "31",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": "minutes",
																			"token": "number",
																			"type": "int_const 60",
																			"value": "1"
																		},
																		"id": 552,
																		"name": "Literal",
																		"src": "3800:9:1"
																	}
																],
																"id": 553,
																"name": "BinaryOperation",
																"src": "3780:29:1"
															}
														],
														"id": 554,
														"name": "BinaryOperation",
														"src": "3774:35:1"
													}
												],
												"id": 555,
												"name": "Assignment",
												"src": "3755:54:1"
											}
										],
										"id": 556,
										"name": "ExpressionStatement",
										"src": "3755:54:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "executed",
															"referencedDeclaration": 324,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 557,
																"name": "Identifier",
																"src": "3820:1:1"
															}
														],
														"id": 559,
														"name": "MemberAccess",
														"src": "3820:10:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "66616c7365",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "false"
														},
														"id": 560,
														"name": "Literal",
														"src": "3833:5:1"
													}
												],
												"id": 561,
												"name": "Assignment",
												"src": "3820:18:1"
											}
										],
										"id": 562,
										"name": "ExpressionStatement",
										"src": "3820:18:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "numberOfVotes",
															"referencedDeclaration": 334,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 563,
																"name": "Identifier",
																"src": "3849:1:1"
															}
														],
														"id": 565,
														"name": "MemberAccess",
														"src": "3849:15:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 566,
														"name": "Literal",
														"src": "3867:1:1"
													}
												],
												"id": 567,
												"name": "Assignment",
												"src": "3849:19:1"
											}
										],
										"id": 568,
										"name": "ExpressionStatement",
										"src": "3849:19:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "yes",
															"referencedDeclaration": 338,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 569,
																"name": "Identifier",
																"src": "3879:1:1"
															}
														],
														"id": 571,
														"name": "MemberAccess",
														"src": "3879:5:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 572,
														"name": "Literal",
														"src": "3887:1:1"
													}
												],
												"id": 573,
												"name": "Assignment",
												"src": "3879:9:1"
											}
										],
										"id": 574,
										"name": "ExpressionStatement",
										"src": "3879:9:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "no",
															"referencedDeclaration": 340,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 575,
																"name": "Identifier",
																"src": "3899:1:1"
															}
														],
														"id": 577,
														"name": "MemberAccess",
														"src": "3899:4:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 578,
														"name": "Literal",
														"src": "3906:1:1"
													}
												],
												"id": 579,
												"name": "Assignment",
												"src": "3899:8:1"
											}
										],
										"id": 580,
										"name": "ExpressionStatement",
										"src": "3899:8:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "minimumQuorum",
															"referencedDeclaration": 336,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 581,
																"name": "Identifier",
																"src": "3918:1:1"
															}
														],
														"id": 583,
														"name": "MemberAccess",
														"src": "3918:15:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 490,
															"type": "uint256",
															"value": "minimumVotes"
														},
														"id": 584,
														"name": "Identifier",
														"src": "3936:12:1"
													}
												],
												"id": 585,
												"name": "Assignment",
												"src": "3918:30:1"
											}
										],
										"id": 586,
										"name": "ExpressionStatement",
										"src": "3918:30:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "debatingPeriodInMinutes",
															"referencedDeclaration": 342,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 514,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 587,
																"name": "Identifier",
																"src": "3959:1:1"
															}
														],
														"id": 589,
														"name": "MemberAccess",
														"src": "3959:25:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 492,
															"type": "uint256",
															"value": "debatingInMinutes"
														},
														"id": 590,
														"name": "Identifier",
														"src": "3987:17:1"
													}
												],
												"id": 591,
												"name": "Assignment",
												"src": "3959:45:1"
											}
										],
										"id": 592,
										"name": "ExpressionStatement",
										"src": "3959:45:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 264,
															"type": "uint256",
															"value": "numProposals"
														},
														"id": 593,
														"name": "Identifier",
														"src": "4015:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "31",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 1",
															"value": "1"
														},
														"id": 594,
														"name": "Literal",
														"src": "4031:1:1"
													}
												],
												"id": 595,
												"name": "Assignment",
												"src": "4015:17:1"
											}
										],
										"id": 596,
										"name": "ExpressionStatement",
										"src": "4015:17:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 290,
															"type": "function (uint256,address,uint256,uint256,uint256,string memory)",
															"value": "ProposalAdded"
														},
														"id": 597,
														"name": "Identifier",
														"src": "4043:13:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 505,
															"type": "uint256",
															"value": "proposalId"
														},
														"id": 598,
														"name": "Identifier",
														"src": "4057:10:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 488,
															"type": "address",
															"value": "beneficiary"
														},
														"id": 599,
														"name": "Identifier",
														"src": "4069:11:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 490,
															"type": "uint256",
															"value": "minimumVotes"
														},
														"id": 600,
														"name": "Identifier",
														"src": "4082:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 492,
															"type": "uint256",
															"value": "debatingInMinutes"
														},
														"id": 601,
														"name": "Identifier",
														"src": "4096:17:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 494,
															"type": "uint256",
															"value": "weiAmount"
														},
														"id": 602,
														"name": "Identifier",
														"src": "4115:9:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 496,
															"type": "string memory",
															"value": "jobDescription"
														},
														"id": 603,
														"name": "Identifier",
														"src": "4126:14:1"
													}
												],
												"id": 604,
												"name": "FunctionCall",
												"src": "4043:98:1"
											}
										],
										"id": 605,
										"name": "ExpressionStatement",
										"src": "4043:98:1"
									},
									{
										"attributes": {
											"functionReturnParameters": 506
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"overloadedDeclarations": [
														null
													],
													"referencedDeclaration": 505,
													"type": "uint256",
													"value": "proposalId"
												},
												"id": 606,
												"name": "Identifier",
												"src": "4169:10:1"
											}
										],
										"id": 607,
										"name": "Return",
										"src": "4162:17:1"
									}
								],
								"id": 608,
								"name": "Block",
								"src": "3445:742:1"
							}
						],
						"id": 609,
						"name": "FunctionDefinition",
						"src": "3143:1044:1"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"name": "checkProposalCode",
							"payable": false,
							"scope": 899,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "proposalNumber",
											"scope": 640,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 610,
												"name": "ElementaryTypeName",
												"src": "4528:4:1"
											}
										],
										"id": 611,
										"name": "VariableDeclaration",
										"src": "4528:19:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "beneficiary",
											"scope": 640,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 612,
												"name": "ElementaryTypeName",
												"src": "4562:7:1"
											}
										],
										"id": 613,
										"name": "VariableDeclaration",
										"src": "4562:19:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "weiAmount",
											"scope": 640,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 614,
												"name": "ElementaryTypeName",
												"src": "4596:4:1"
											}
										],
										"id": 615,
										"name": "VariableDeclaration",
										"src": "4596:14:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "transactionBytecode",
											"scope": 640,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes",
													"type": "bytes storage pointer"
												},
												"id": 616,
												"name": "ElementaryTypeName",
												"src": "4625:5:1"
											}
										],
										"id": 617,
										"name": "VariableDeclaration",
										"src": "4625:25:1"
									}
								],
								"id": 618,
								"name": "ParameterList",
								"src": "4513:138:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "codeChecksOut",
											"scope": 640,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 621,
												"name": "ElementaryTypeName",
												"src": "4696:4:1"
											}
										],
										"id": 622,
										"name": "VariableDeclaration",
										"src": "4696:18:1"
									}
								],
								"id": 623,
								"name": "ParameterList",
								"src": "4695:20:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 417,
											"type": "modifier ()",
											"value": "isCitizen"
										},
										"id": 619,
										"name": "Identifier",
										"src": "4661:9:1"
									}
								],
								"id": 620,
								"name": "ModifierInvocation",
								"src": "4661:9:1"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												625
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "p",
													"scope": 640,
													"stateVariable": false,
													"storageLocation": "storage",
													"type": "struct Democracy.Proposal storage pointer",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"contractScope": null,
															"name": "Proposal",
															"referencedDeclaration": 350,
															"type": "struct Democracy.Proposal storage pointer"
														},
														"id": 624,
														"name": "UserDefinedTypeName",
														"src": "4740:8:1"
													}
												],
												"id": 625,
												"name": "VariableDeclaration",
												"src": "4740:18:1"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct Democracy.Proposal storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 262,
															"type": "struct Democracy.Proposal storage ref[] storage ref",
															"value": "proposals"
														},
														"id": 626,
														"name": "Identifier",
														"src": "4761:9:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 611,
															"type": "uint256",
															"value": "proposalNumber"
														},
														"id": 627,
														"name": "Identifier",
														"src": "4771:14:1"
													}
												],
												"id": 628,
												"name": "IndexAccess",
												"src": "4761:25:1"
											}
										],
										"id": 629,
										"name": "VariableDeclarationStatement",
										"src": "4740:46:1"
									},
									{
										"attributes": {
											"functionReturnParameters": 623
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "==",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "proposalHash",
															"referencedDeclaration": 328,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 625,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 630,
																"name": "Identifier",
																"src": "4804:1:1"
															}
														],
														"id": 631,
														"name": "MemberAccess",
														"src": "4804:14:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "bytes32",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		},
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_bytes_memory_ptr",
																			"typeString": "bytes memory"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1388,
																	"type": "function () pure returns (bytes32)",
																	"value": "keccak256"
																},
																"id": 632,
																"name": "Identifier",
																"src": "4822:9:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 613,
																	"type": "address",
																	"value": "beneficiary"
																},
																"id": 633,
																"name": "Identifier",
																"src": "4832:11:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 615,
																	"type": "uint256",
																	"value": "weiAmount"
																},
																"id": 634,
																"name": "Identifier",
																"src": "4845:9:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 617,
																	"type": "bytes memory",
																	"value": "transactionBytecode"
																},
																"id": 635,
																"name": "Identifier",
																"src": "4856:19:1"
															}
														],
														"id": 636,
														"name": "FunctionCall",
														"src": "4822:54:1"
													}
												],
												"id": 637,
												"name": "BinaryOperation",
												"src": "4804:72:1"
											}
										],
										"id": 638,
										"name": "Return",
										"src": "4797:79:1"
									}
								],
								"id": 639,
								"name": "Block",
								"src": "4715:169:1"
							}
						],
						"id": 640,
						"name": "FunctionDefinition",
						"src": "4487:397:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "vote",
							"payable": false,
							"scope": 899,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "proposalNumber",
											"scope": 736,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 641,
												"name": "ElementaryTypeName",
												"src": "5183:4:1"
											}
										],
										"id": 642,
										"name": "VariableDeclaration",
										"src": "5183:19:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "supportsProposal",
											"scope": 736,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 643,
												"name": "ElementaryTypeName",
												"src": "5217:4:1"
											}
										],
										"id": 644,
										"name": "VariableDeclaration",
										"src": "5217:21:1"
									}
								],
								"id": 645,
								"name": "ParameterList",
								"src": "5168:71:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "voteId",
											"scope": 736,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 650,
												"name": "ElementaryTypeName",
												"src": "5295:4:1"
											}
										],
										"id": 651,
										"name": "VariableDeclaration",
										"src": "5295:11:1"
									}
								],
								"id": 652,
								"name": "ParameterList",
								"src": "5294:13:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 369,
											"type": "modifier ()",
											"value": "onlyShareholders"
										},
										"id": 646,
										"name": "Identifier",
										"src": "5249:16:1"
									}
								],
								"id": 647,
								"name": "ModifierInvocation",
								"src": "5249:16:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 390,
											"type": "modifier ()",
											"value": "onlyInBudget"
										},
										"id": 648,
										"name": "Identifier",
										"src": "5266:12:1"
									}
								],
								"id": 649,
								"name": "ModifierInvocation",
								"src": "5266:12:1"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												654
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "p",
													"scope": 736,
													"stateVariable": false,
													"storageLocation": "storage",
													"type": "struct Democracy.Proposal storage pointer",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"contractScope": null,
															"name": "Proposal",
															"referencedDeclaration": 350,
															"type": "struct Democracy.Proposal storage pointer"
														},
														"id": 653,
														"name": "UserDefinedTypeName",
														"src": "5332:8:1"
													}
												],
												"id": 654,
												"name": "VariableDeclaration",
												"src": "5332:18:1"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct Democracy.Proposal storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 262,
															"type": "struct Democracy.Proposal storage ref[] storage ref",
															"value": "proposals"
														},
														"id": 655,
														"name": "Identifier",
														"src": "5353:9:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 642,
															"type": "uint256",
															"value": "proposalNumber"
														},
														"id": 656,
														"name": "Identifier",
														"src": "5363:14:1"
													}
												],
												"id": 657,
												"name": "IndexAccess",
												"src": "5353:25:1"
											}
										],
										"id": 658,
										"name": "VariableDeclarationStatement",
										"src": "5332:46:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 659,
														"name": "Identifier",
														"src": "5389:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "voted",
																					"referencedDeclaration": 349,
																					"type": "mapping(address => bool)"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 654,
																							"type": "struct Democracy.Proposal storage pointer",
																							"value": "p"
																						},
																						"id": 660,
																						"name": "Identifier",
																						"src": "5397:1:1"
																					}
																				],
																				"id": 661,
																				"name": "MemberAccess",
																				"src": "5397:7:1"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1394,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 662,
																						"name": "Identifier",
																						"src": "5405:3:1"
																					}
																				],
																				"id": 663,
																				"name": "MemberAccess",
																				"src": "5405:10:1"
																			}
																		],
																		"id": 664,
																		"name": "IndexAccess",
																		"src": "5397:19:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "74727565",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "bool",
																			"type": "bool",
																			"value": "true"
																		},
																		"id": 665,
																		"name": "Literal",
																		"src": "5420:4:1"
																	}
																],
																"id": 666,
																"name": "BinaryOperation",
																"src": "5397:27:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "<",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1396,
																			"type": "uint256",
																			"value": "now"
																		},
																		"id": 667,
																		"name": "Identifier",
																		"src": "5441:3:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "votingDeadline",
																			"referencedDeclaration": 330,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 654,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 668,
																				"name": "Identifier",
																				"src": "5447:1:1"
																			}
																		],
																		"id": 669,
																		"name": "MemberAccess",
																		"src": "5447:16:1"
																	}
																],
																"id": 670,
																"name": "BinaryOperation",
																"src": "5441:22:1"
															}
														],
														"id": 671,
														"name": "BinaryOperation",
														"src": "5397:66:1"
													}
												],
												"id": 672,
												"name": "FunctionCall",
												"src": "5389:75:1"
											}
										],
										"id": 673,
										"name": "ExpressionStatement",
										"src": "5389:75:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 651,
															"type": "uint256",
															"value": "voteId"
														},
														"id": 674,
														"name": "Identifier",
														"src": "5477:6:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "++",
															"prefix": false,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"member_name": "length",
																	"referencedDeclaration": null,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "votes",
																			"referencedDeclaration": 345,
																			"type": "struct Democracy.Vote storage ref[] storage ref"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 654,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 675,
																				"name": "Identifier",
																				"src": "5486:1:1"
																			}
																		],
																		"id": 676,
																		"name": "MemberAccess",
																		"src": "5486:7:1"
																	}
																],
																"id": 677,
																"name": "MemberAccess",
																"src": "5486:14:1"
															}
														],
														"id": 678,
														"name": "UnaryOperation",
														"src": "5486:16:1"
													}
												],
												"id": 679,
												"name": "Assignment",
												"src": "5477:25:1"
											}
										],
										"id": 680,
										"name": "ExpressionStatement",
										"src": "5477:25:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "struct Democracy.Vote storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "struct Democracy.Vote storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "votes",
																	"referencedDeclaration": 345,
																	"type": "struct Democracy.Vote storage ref[] storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 654,
																			"type": "struct Democracy.Proposal storage pointer",
																			"value": "p"
																		},
																		"id": 681,
																		"name": "Identifier",
																		"src": "5513:1:1"
																	}
																],
																"id": 684,
																"name": "MemberAccess",
																"src": "5513:7:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 651,
																	"type": "uint256",
																	"value": "voteId"
																},
																"id": 683,
																"name": "Identifier",
																"src": "5521:6:1"
															}
														],
														"id": 685,
														"name": "IndexAccess",
														"src": "5513:15:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": true,
															"lValueRequested": false,
															"names": [
																"inSupport",
																"voter"
															],
															"type": "struct Democracy.Vote memory",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 355,
																	"type": "type(struct Democracy.Vote storage pointer)",
																	"value": "Vote"
																},
																"id": 686,
																"name": "Identifier",
																"src": "5531:4:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 644,
																	"type": "bool",
																	"value": "supportsProposal"
																},
																"id": 687,
																"name": "Identifier",
																"src": "5548:16:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 688,
																		"name": "Identifier",
																		"src": "5573:3:1"
																	}
																],
																"id": 689,
																"name": "MemberAccess",
																"src": "5573:10:1"
															}
														],
														"id": 690,
														"name": "FunctionCall",
														"src": "5531:54:1"
													}
												],
												"id": 691,
												"name": "Assignment",
												"src": "5513:72:1"
											}
										],
										"id": 692,
										"name": "ExpressionStatement",
										"src": "5513:72:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "voted",
																	"referencedDeclaration": 349,
																	"type": "mapping(address => bool)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 654,
																			"type": "struct Democracy.Proposal storage pointer",
																			"value": "p"
																		},
																		"id": 693,
																		"name": "Identifier",
																		"src": "5596:1:1"
																	}
																],
																"id": 697,
																"name": "MemberAccess",
																"src": "5596:7:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 695,
																		"name": "Identifier",
																		"src": "5604:3:1"
																	}
																],
																"id": 696,
																"name": "MemberAccess",
																"src": "5604:10:1"
															}
														],
														"id": 698,
														"name": "IndexAccess",
														"src": "5596:19:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "74727565",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "true"
														},
														"id": 699,
														"name": "Literal",
														"src": "5618:4:1"
													}
												],
												"id": 700,
												"name": "Assignment",
												"src": "5596:26:1"
											}
										],
										"id": 701,
										"name": "ExpressionStatement",
										"src": "5596:26:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "numberOfVotes",
															"referencedDeclaration": 334,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 654,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 702,
																"name": "Identifier",
																"src": "5633:1:1"
															}
														],
														"id": 704,
														"name": "MemberAccess",
														"src": "5633:15:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "+",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 651,
																	"type": "uint256",
																	"value": "voteId"
																},
																"id": 705,
																"name": "Identifier",
																"src": "5651:6:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "31",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 1",
																	"value": "1"
																},
																"id": 706,
																"name": "Literal",
																"src": "5659:1:1"
															}
														],
														"id": 707,
														"name": "BinaryOperation",
														"src": "5651:9:1"
													}
												],
												"id": 708,
												"name": "Assignment",
												"src": "5633:27:1"
											}
										],
										"id": 709,
										"name": "ExpressionStatement",
										"src": "5633:27:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"overloadedDeclarations": [
														null
													],
													"referencedDeclaration": 644,
													"type": "bool",
													"value": "supportsProposal"
												},
												"id": 710,
												"name": "Identifier",
												"src": "5675:16:1"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "+=",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": true,
																			"member_name": "yes",
																			"referencedDeclaration": 338,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 654,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 711,
																				"name": "Identifier",
																				"src": "5707:1:1"
																			}
																		],
																		"id": 713,
																		"name": "MemberAccess",
																		"src": "5707:5:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "31",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 1",
																			"value": "1"
																		},
																		"id": 714,
																		"name": "Literal",
																		"src": "5716:1:1"
																	}
																],
																"id": 715,
																"name": "Assignment",
																"src": "5707:10:1"
															}
														],
														"id": 716,
														"name": "ExpressionStatement",
														"src": "5707:10:1"
													}
												],
												"id": 717,
												"name": "Block",
												"src": "5692:37:1"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "+=",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": true,
																			"member_name": "no",
																			"referencedDeclaration": 340,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 654,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 718,
																				"name": "Identifier",
																				"src": "5750:1:1"
																			}
																		],
																		"id": 720,
																		"name": "MemberAccess",
																		"src": "5750:4:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "31",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 1",
																			"value": "1"
																		},
																		"id": 721,
																		"name": "Literal",
																		"src": "5758:1:1"
																	}
																],
																"id": 722,
																"name": "Assignment",
																"src": "5750:9:1"
															}
														],
														"id": 723,
														"name": "ExpressionStatement",
														"src": "5750:9:1"
													}
												],
												"id": 724,
												"name": "Block",
												"src": "5735:36:1"
											}
										],
										"id": 725,
										"name": "IfStatement",
										"src": "5671:100:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 298,
															"type": "function (uint256,bool,address)",
															"value": "Voted"
														},
														"id": 726,
														"name": "Identifier",
														"src": "5781:5:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 642,
															"type": "uint256",
															"value": "proposalNumber"
														},
														"id": 727,
														"name": "Identifier",
														"src": "5787:14:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 644,
															"type": "bool",
															"value": "supportsProposal"
														},
														"id": 728,
														"name": "Identifier",
														"src": "5803:16:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1394,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 729,
																"name": "Identifier",
																"src": "5821:3:1"
															}
														],
														"id": 730,
														"name": "MemberAccess",
														"src": "5821:10:1"
													}
												],
												"id": 731,
												"name": "FunctionCall",
												"src": "5781:51:1"
											}
										],
										"id": 732,
										"name": "ExpressionStatement",
										"src": "5781:51:1"
									},
									{
										"attributes": {
											"functionReturnParameters": 652
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"overloadedDeclarations": [
														null
													],
													"referencedDeclaration": 651,
													"type": "uint256",
													"value": "voteId"
												},
												"id": 733,
												"name": "Identifier",
												"src": "5860:6:1"
											}
										],
										"id": 734,
										"name": "Return",
										"src": "5853:13:1"
									}
								],
								"id": 735,
								"name": "Block",
								"src": "5307:567:1"
							}
						],
						"id": 736,
						"name": "FunctionDefinition",
						"src": "5155:719:1"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "checkProposalVoter",
							"payable": false,
							"scope": 899,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "proposalId",
											"scope": 753,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 737,
												"name": "ElementaryTypeName",
												"src": "5914:4:1"
											}
										],
										"id": 738,
										"name": "VariableDeclaration",
										"src": "5914:15:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "voter",
											"scope": 753,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 739,
												"name": "ElementaryTypeName",
												"src": "5931:7:1"
											}
										],
										"id": 740,
										"name": "VariableDeclaration",
										"src": "5931:13:1"
									}
								],
								"id": 741,
								"name": "ParameterList",
								"src": "5913:32:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "voted",
											"scope": 753,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 742,
												"name": "ElementaryTypeName",
												"src": "5971:4:1"
											}
										],
										"id": 743,
										"name": "VariableDeclaration",
										"src": "5971:10:1"
									}
								],
								"id": 744,
								"name": "ParameterList",
								"src": "5970:12:1"
							},
							{
								"children": [
									{
										"attributes": {
											"functionReturnParameters": 744
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "voted",
															"referencedDeclaration": 349,
															"type": "mapping(address => bool)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct Democracy.Proposal storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 262,
																			"type": "struct Democracy.Proposal storage ref[] storage ref",
																			"value": "proposals"
																		},
																		"id": 745,
																		"name": "Identifier",
																		"src": "6000:9:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 738,
																			"type": "uint256",
																			"value": "proposalId"
																		},
																		"id": 746,
																		"name": "Identifier",
																		"src": "6010:10:1"
																	}
																],
																"id": 747,
																"name": "IndexAccess",
																"src": "6000:21:1"
															}
														],
														"id": 748,
														"name": "MemberAccess",
														"src": "6000:27:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 740,
															"type": "address",
															"value": "voter"
														},
														"id": 749,
														"name": "Identifier",
														"src": "6028:5:1"
													}
												],
												"id": 750,
												"name": "IndexAccess",
												"src": "6000:34:1"
											}
										],
										"id": 751,
										"name": "Return",
										"src": "5993:41:1"
									}
								],
								"id": 752,
								"name": "Block",
								"src": "5982:60:1"
							}
						],
						"id": 753,
						"name": "FunctionDefinition",
						"src": "5886:156:1"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "checkProposalDeadline",
							"payable": false,
							"scope": 899,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "proposalId",
											"scope": 774,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 754,
												"name": "ElementaryTypeName",
												"src": "6085:4:1"
											}
										],
										"id": 755,
										"name": "VariableDeclaration",
										"src": "6085:15:1"
									}
								],
								"id": 756,
								"name": "ParameterList",
								"src": "6084:17:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "isDeadlineOver",
											"scope": 774,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 757,
												"name": "ElementaryTypeName",
												"src": "6127:4:1"
											}
										],
										"id": 758,
										"name": "VariableDeclaration",
										"src": "6127:19:1"
									}
								],
								"id": 759,
								"name": "ParameterList",
								"src": "6126:21:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": ">",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1396,
															"type": "uint256",
															"value": "now"
														},
														"id": 760,
														"name": "Identifier",
														"src": "6162:3:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "votingDeadline",
															"referencedDeclaration": 330,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct Democracy.Proposal storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 262,
																			"type": "struct Democracy.Proposal storage ref[] storage ref",
																			"value": "proposals"
																		},
																		"id": 761,
																		"name": "Identifier",
																		"src": "6168:9:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 755,
																			"type": "uint256",
																			"value": "proposalId"
																		},
																		"id": 762,
																		"name": "Identifier",
																		"src": "6178:10:1"
																	}
																],
																"id": 763,
																"name": "IndexAccess",
																"src": "6168:21:1"
															}
														],
														"id": 764,
														"name": "MemberAccess",
														"src": "6168:36:1"
													}
												],
												"id": 765,
												"name": "BinaryOperation",
												"src": "6162:42:1"
											},
											{
												"children": [
													{
														"attributes": {
															"functionReturnParameters": 759
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "74727565",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "bool",
																	"type": "bool",
																	"value": "true"
																},
																"id": 766,
																"name": "Literal",
																"src": "6227:4:1"
															}
														],
														"id": 767,
														"name": "Return",
														"src": "6220:11:1"
													}
												],
												"id": 768,
												"name": "Block",
												"src": "6205:38:1"
											},
											{
												"children": [
													{
														"attributes": {
															"functionReturnParameters": 759
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "66616c7365",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "bool",
																	"type": "bool",
																	"value": "false"
																},
																"id": 769,
																"name": "Literal",
																"src": "6271:5:1"
															}
														],
														"id": 770,
														"name": "Return",
														"src": "6264:12:1"
													}
												],
												"id": 771,
												"name": "Block",
												"src": "6249:39:1"
											}
										],
										"id": 772,
										"name": "IfStatement",
										"src": "6158:130:1"
									}
								],
								"id": 773,
								"name": "Block",
								"src": "6147:148:1"
							}
						],
						"id": 774,
						"name": "FunctionDefinition",
						"src": "6054:241:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "executeProposal",
							"payable": false,
							"scope": 899,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "proposalNumber",
											"scope": 862,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 775,
												"name": "ElementaryTypeName",
												"src": "6612:4:1"
											}
										],
										"id": 776,
										"name": "VariableDeclaration",
										"src": "6612:19:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "transactionBytecode",
											"scope": 862,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes",
													"type": "bytes storage pointer"
												},
												"id": 777,
												"name": "ElementaryTypeName",
												"src": "6633:5:1"
											}
										],
										"id": 778,
										"name": "VariableDeclaration",
										"src": "6633:25:1"
									}
								],
								"id": 779,
								"name": "ParameterList",
								"src": "6611:48:1"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 784,
								"name": "ParameterList",
								"src": "6697:0:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 369,
											"type": "modifier ()",
											"value": "onlyShareholders"
										},
										"id": 780,
										"name": "Identifier",
										"src": "6660:16:1"
									}
								],
								"id": 781,
								"name": "ModifierInvocation",
								"src": "6660:16:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 390,
											"type": "modifier ()",
											"value": "onlyInBudget"
										},
										"id": 782,
										"name": "Identifier",
										"src": "6677:12:1"
									}
								],
								"id": 783,
								"name": "ModifierInvocation",
								"src": "6677:12:1"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												786
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "p",
													"scope": 862,
													"stateVariable": false,
													"storageLocation": "storage",
													"type": "struct Democracy.Proposal storage pointer",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"contractScope": null,
															"name": "Proposal",
															"referencedDeclaration": 350,
															"type": "struct Democracy.Proposal storage pointer"
														},
														"id": 785,
														"name": "UserDefinedTypeName",
														"src": "6708:8:1"
													}
												],
												"id": 786,
												"name": "VariableDeclaration",
												"src": "6708:18:1"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct Democracy.Proposal storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 262,
															"type": "struct Democracy.Proposal storage ref[] storage ref",
															"value": "proposals"
														},
														"id": 787,
														"name": "Identifier",
														"src": "6729:9:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 776,
															"type": "uint256",
															"value": "proposalNumber"
														},
														"id": 788,
														"name": "Identifier",
														"src": "6739:14:1"
													}
												],
												"id": 789,
												"name": "IndexAccess",
												"src": "6729:25:1"
											}
										],
										"id": 790,
										"name": "VariableDeclarationStatement",
										"src": "6708:46:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 791,
														"name": "Identifier",
														"src": "6767:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "&&",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "&&",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint256",
																						"typeString": "uint256"
																					},
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"operator": ">",
																					"type": "bool"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1396,
																							"type": "uint256",
																							"value": "now"
																						},
																						"id": 792,
																						"name": "Identifier",
																						"src": "6775:3:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "votingDeadline",
																							"referencedDeclaration": 330,
																							"type": "uint256"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 786,
																									"type": "struct Democracy.Proposal storage pointer",
																									"value": "p"
																								},
																								"id": 793,
																								"name": "Identifier",
																								"src": "6781:1:1"
																							}
																						],
																						"id": 794,
																						"name": "MemberAccess",
																						"src": "6781:16:1"
																					}
																				],
																				"id": 795,
																				"name": "BinaryOperation",
																				"src": "6775:22:1"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"operator": "!",
																					"prefix": true,
																					"type": "bool"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "executed",
																							"referencedDeclaration": 324,
																							"type": "bool"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 786,
																									"type": "struct Democracy.Proposal storage pointer",
																									"value": "p"
																								},
																								"id": 796,
																								"name": "Identifier",
																								"src": "6896:1:1"
																							}
																						],
																						"id": 797,
																						"name": "MemberAccess",
																						"src": "6896:10:1"
																					}
																				],
																				"id": 798,
																				"name": "UnaryOperation",
																				"src": "6895:11:1"
																			}
																		],
																		"id": 799,
																		"name": "BinaryOperation",
																		"src": "6775:131:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_bytes32",
																				"typeString": "bytes32"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "==",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "proposalHash",
																					"referencedDeclaration": 328,
																					"type": "bytes32"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 786,
																							"type": "struct Democracy.Proposal storage pointer",
																							"value": "p"
																						},
																						"id": 800,
																						"name": "Identifier",
																						"src": "7020:1:1"
																					}
																				],
																				"id": 801,
																				"name": "MemberAccess",
																				"src": "7020:14:1"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"isStructConstructorCall": false,
																					"lValueRequested": false,
																					"names": [
																						null
																					],
																					"type": "bytes32",
																					"type_conversion": false
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": [
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								},
																								{
																									"typeIdentifier": "t_bytes_memory_ptr",
																									"typeString": "bytes memory"
																								}
																							],
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1388,
																							"type": "function () pure returns (bytes32)",
																							"value": "keccak256"
																						},
																						"id": 802,
																						"name": "Identifier",
																						"src": "7038:9:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "recipient",
																							"referencedDeclaration": 322,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 786,
																									"type": "struct Democracy.Proposal storage pointer",
																									"value": "p"
																								},
																								"id": 803,
																								"name": "Identifier",
																								"src": "7048:1:1"
																							}
																						],
																						"id": 804,
																						"name": "MemberAccess",
																						"src": "7048:11:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "amount",
																							"referencedDeclaration": 332,
																							"type": "uint256"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 786,
																									"type": "struct Democracy.Proposal storage pointer",
																									"value": "p"
																								},
																								"id": 805,
																								"name": "Identifier",
																								"src": "7061:1:1"
																							}
																						],
																						"id": 806,
																						"name": "MemberAccess",
																						"src": "7061:8:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 778,
																							"type": "bytes memory",
																							"value": "transactionBytecode"
																						},
																						"id": 807,
																						"name": "Identifier",
																						"src": "7071:19:1"
																					}
																				],
																				"id": 808,
																				"name": "FunctionCall",
																				"src": "7038:53:1"
																			}
																		],
																		"id": 809,
																		"name": "BinaryOperation",
																		"src": "7020:71:1"
																	}
																],
																"id": 810,
																"name": "BinaryOperation",
																"src": "6775:316:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": ">=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "numberOfVotes",
																			"referencedDeclaration": 334,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 786,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 811,
																				"name": "Identifier",
																				"src": "7108:1:1"
																			}
																		],
																		"id": 812,
																		"name": "MemberAccess",
																		"src": "7108:15:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "minimumQuorum",
																			"referencedDeclaration": 336,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 786,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 813,
																				"name": "Identifier",
																				"src": "7127:1:1"
																			}
																		],
																		"id": 814,
																		"name": "MemberAccess",
																		"src": "7127:15:1"
																	}
																],
																"id": 815,
																"name": "BinaryOperation",
																"src": "7108:34:1"
															}
														],
														"id": 816,
														"name": "BinaryOperation",
														"src": "6775:367:1"
													}
												],
												"id": 817,
												"name": "FunctionCall",
												"src": "6767:376:1"
											}
										],
										"id": 818,
										"name": "ExpressionStatement",
										"src": "6767:376:1"
									},
									{
										"attributes": {
											"falseBody": null
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": ">",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "yes",
															"referencedDeclaration": 338,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 786,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 819,
																"name": "Identifier",
																"src": "7209:1:1"
															}
														],
														"id": 820,
														"name": "MemberAccess",
														"src": "7209:5:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "no",
															"referencedDeclaration": 340,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 786,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 821,
																"name": "Identifier",
																"src": "7217:1:1"
															}
														],
														"id": 822,
														"name": "MemberAccess",
														"src": "7217:4:1"
													}
												],
												"id": 823,
												"name": "BinaryOperation",
												"src": "7209:12:1"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": true,
																			"member_name": "executed",
																			"referencedDeclaration": 324,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 786,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 824,
																				"name": "Identifier",
																				"src": "7298:1:1"
																			}
																		],
																		"id": 826,
																		"name": "MemberAccess",
																		"src": "7298:10:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "74727565",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "bool",
																			"type": "bool",
																			"value": "true"
																		},
																		"id": 827,
																		"name": "Literal",
																		"src": "7311:4:1"
																	}
																],
																"id": 828,
																"name": "Assignment",
																"src": "7298:17:1"
															}
														],
														"id": 829,
														"name": "ExpressionStatement",
														"src": "7298:17:1"
													},
													{
														"attributes": {
															"falseBody": null
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "recipient",
																			"referencedDeclaration": 322,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 786,
																					"type": "struct Democracy.Proposal storage pointer",
																					"value": "p"
																				},
																				"id": 830,
																				"name": "Identifier",
																				"src": "7333:1:1"
																			}
																		],
																		"id": 831,
																		"name": "MemberAccess",
																		"src": "7333:11:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"isStructConstructorCall": false,
																			"lValueRequested": false,
																			"names": [
																				null
																			],
																			"type": "address",
																			"type_conversion": true
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": [
																						{
																							"typeIdentifier": "t_contract$_Democracy_$899",
																							"typeString": "contract Democracy"
																						}
																					],
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"type": "type(address)",
																					"value": "address"
																				},
																				"id": 832,
																				"name": "ElementaryTypeNameExpression",
																				"src": "7348:7:1"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1415,
																					"type": "contract Democracy",
																					"value": "this"
																				},
																				"id": 833,
																				"name": "Identifier",
																				"src": "7356:4:1"
																			}
																		],
																		"id": 834,
																		"name": "FunctionCall",
																		"src": "7348:13:1"
																	}
																],
																"id": 835,
																"name": "BinaryOperation",
																"src": "7333:28:1"
															},
															{
																"children": [
																	{
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"isStructConstructorCall": false,
																					"lValueRequested": false,
																					"names": [
																						null
																					],
																					"type": "tuple()",
																					"type_conversion": false
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": [
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								},
																								{
																									"typeIdentifier": "t_bytes_memory_ptr",
																									"typeString": "bytes memory"
																								}
																							],
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 898,
																							"type": "function (address,uint256,bytes memory)",
																							"value": "_safeWithdrawal"
																						},
																						"id": 836,
																						"name": "Identifier",
																						"src": "7381:15:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "recipient",
																							"referencedDeclaration": 322,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 786,
																									"type": "struct Democracy.Proposal storage pointer",
																									"value": "p"
																								},
																								"id": 837,
																								"name": "Identifier",
																								"src": "7397:1:1"
																							}
																						],
																						"id": 838,
																						"name": "MemberAccess",
																						"src": "7397:11:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "amount",
																							"referencedDeclaration": 332,
																							"type": "uint256"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 786,
																									"type": "struct Democracy.Proposal storage pointer",
																									"value": "p"
																								},
																								"id": 839,
																								"name": "Identifier",
																								"src": "7410:1:1"
																							}
																						],
																						"id": 840,
																						"name": "MemberAccess",
																						"src": "7410:8:1"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 778,
																							"type": "bytes memory",
																							"value": "transactionBytecode"
																						},
																						"id": 841,
																						"name": "Identifier",
																						"src": "7420:19:1"
																					}
																				],
																				"id": 842,
																				"name": "FunctionCall",
																				"src": "7381:59:1"
																			}
																		],
																		"id": 843,
																		"name": "ExpressionStatement",
																		"src": "7381:59:1"
																	}
																],
																"id": 844,
																"name": "Block",
																"src": "7362:94:1"
															}
														],
														"id": 845,
														"name": "IfStatement",
														"src": "7330:126:1"
													}
												],
												"id": 846,
												"name": "Block",
												"src": "7224:322:1"
											}
										],
										"id": 847,
										"name": "IfStatement",
										"src": "7205:341:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 308,
															"type": "function (uint256,uint256,uint256,bool)",
															"value": "ProposalTallied"
														},
														"id": 848,
														"name": "Identifier",
														"src": "7582:15:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 776,
															"type": "uint256",
															"value": "proposalNumber"
														},
														"id": 849,
														"name": "Identifier",
														"src": "7598:14:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "-",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "yes",
																	"referencedDeclaration": 338,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 786,
																			"type": "struct Democracy.Proposal storage pointer",
																			"value": "p"
																		},
																		"id": 850,
																		"name": "Identifier",
																		"src": "7614:1:1"
																	}
																],
																"id": 851,
																"name": "MemberAccess",
																"src": "7614:5:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "no",
																	"referencedDeclaration": 340,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 786,
																			"type": "struct Democracy.Proposal storage pointer",
																			"value": "p"
																		},
																		"id": 852,
																		"name": "Identifier",
																		"src": "7622:1:1"
																	}
																],
																"id": 853,
																"name": "MemberAccess",
																"src": "7622:4:1"
															}
														],
														"id": 854,
														"name": "BinaryOperation",
														"src": "7614:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "numberOfVotes",
															"referencedDeclaration": 334,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 786,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 855,
																"name": "Identifier",
																"src": "7628:1:1"
															}
														],
														"id": 856,
														"name": "MemberAccess",
														"src": "7628:15:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "executed",
															"referencedDeclaration": 324,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 786,
																	"type": "struct Democracy.Proposal storage pointer",
																	"value": "p"
																},
																"id": 857,
																"name": "Identifier",
																"src": "7645:1:1"
															}
														],
														"id": 858,
														"name": "MemberAccess",
														"src": "7645:10:1"
													}
												],
												"id": 859,
												"name": "FunctionCall",
												"src": "7582:74:1"
											}
										],
										"id": 860,
										"name": "ExpressionStatement",
										"src": "7582:74:1"
									}
								],
								"id": 861,
								"name": "Block",
								"src": "6697:967:1"
							}
						],
						"id": 862,
						"name": "FunctionDefinition",
						"src": "6587:1077:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "_safeWithdrawal",
							"payable": false,
							"scope": 899,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "internal"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_beneficiary",
											"scope": 898,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 863,
												"name": "ElementaryTypeName",
												"src": "8005:7:1"
											}
										],
										"id": 864,
										"name": "VariableDeclaration",
										"src": "8005:20:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_value",
											"scope": 898,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 865,
												"name": "ElementaryTypeName",
												"src": "8027:4:1"
											}
										],
										"id": 866,
										"name": "VariableDeclaration",
										"src": "8027:11:1"
									},
									{
										"attributes": {
											"constant": false,
											"name": "transactionBytecode",
											"scope": 898,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes",
													"type": "bytes storage pointer"
												},
												"id": 867,
												"name": "ElementaryTypeName",
												"src": "8040:5:1"
											}
										],
										"id": 868,
										"name": "VariableDeclaration",
										"src": "8040:25:1"
									}
								],
								"id": 869,
								"name": "ParameterList",
								"src": "8004:62:1"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 870,
								"name": "ParameterList",
								"src": "8076:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 871,
														"name": "Identifier",
														"src": "8087:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": ">=",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "balance",
																	"referencedDeclaration": null,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1415,
																			"type": "contract Democracy",
																			"value": "this"
																		},
																		"id": 872,
																		"name": "Identifier",
																		"src": "8095:4:1"
																	}
																],
																"id": 873,
																"name": "MemberAccess",
																"src": "8095:12:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 866,
																	"type": "uint256",
																	"value": "_value"
																},
																"id": 874,
																"name": "Identifier",
																"src": "8111:6:1"
															}
														],
														"id": 875,
														"name": "BinaryOperation",
														"src": "8095:22:1"
													}
												],
												"id": 876,
												"name": "FunctionCall",
												"src": "8087:31:1"
											}
										],
										"id": 877,
										"name": "ExpressionStatement",
										"src": "8087:31:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "-=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 266,
															"type": "uint256",
															"value": "amountRaised"
														},
														"id": 878,
														"name": "Identifier",
														"src": "8129:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 866,
															"type": "uint256",
															"value": "_value"
														},
														"id": 879,
														"name": "Identifier",
														"src": "8145:6:1"
													}
												],
												"id": 880,
												"name": "Assignment",
												"src": "8129:22:1"
											}
										],
										"id": 881,
										"name": "ExpressionStatement",
										"src": "8129:22:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 882,
														"name": "Identifier",
														"src": "8162:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "bool",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_bytes_memory_ptr",
																			"typeString": "bytes memory"
																		}
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "function () payable returns (bool)",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "value",
																			"referencedDeclaration": null,
																			"type": "function (uint256) returns (function () payable returns (bool))"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "call",
																					"referencedDeclaration": null,
																					"type": "function () payable returns (bool)"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 864,
																							"type": "address",
																							"value": "_beneficiary"
																						},
																						"id": 883,
																						"name": "Identifier",
																						"src": "8170:12:1"
																					}
																				],
																				"id": 884,
																				"name": "MemberAccess",
																				"src": "8170:17:1"
																			}
																		],
																		"id": 885,
																		"name": "MemberAccess",
																		"src": "8170:23:1"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 866,
																			"type": "uint256",
																			"value": "_value"
																		},
																		"id": 886,
																		"name": "Identifier",
																		"src": "8194:6:1"
																	}
																],
																"id": 887,
																"name": "FunctionCall",
																"src": "8170:31:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 868,
																	"type": "bytes memory",
																	"value": "transactionBytecode"
																},
																"id": 888,
																"name": "Identifier",
																"src": "8202:19:1"
															}
														],
														"id": 889,
														"name": "FunctionCall",
														"src": "8170:52:1"
													}
												],
												"id": 890,
												"name": "FunctionCall",
												"src": "8162:61:1"
											}
										],
										"id": 891,
										"name": "ExpressionStatement",
										"src": "8162:61:1"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 320,
															"type": "function (address,uint256)",
															"value": "FundTransfer"
														},
														"id": 892,
														"name": "Identifier",
														"src": "8276:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 864,
															"type": "address",
															"value": "_beneficiary"
														},
														"id": 893,
														"name": "Identifier",
														"src": "8289:12:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 866,
															"type": "uint256",
															"value": "_value"
														},
														"id": 894,
														"name": "Identifier",
														"src": "8303:6:1"
													}
												],
												"id": 895,
												"name": "FunctionCall",
												"src": "8276:34:1"
											}
										],
										"id": 896,
										"name": "ExpressionStatement",
										"src": "8276:34:1"
									}
								],
								"id": 897,
								"name": "Block",
								"src": "8076:242:1"
							}
						],
						"id": 898,
						"name": "FunctionDefinition",
						"src": "7980:338:1"
					}
				],
				"id": 899,
				"name": "ContractDefinition",
				"src": "353:7968:1"
			}
		],
		"id": 900,
		"name": "SourceUnit",
		"src": "0:8321:1"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.19+commit.c4cbbb05.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0xb996dc0c83d3e0954b0a82939c7a66439ed04bdb"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-03-13T19:12:20.043Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Democracy.json
// module id = 115
// module chunks = 0